<!-- DAM Section -->
<header class="masthead">
	<div class="navbar">
		<div class="left-header">
			<div class="workspace-title" id="create-workspace" data-toggle="dropdown">
				<div class="user-img">
					<span class="ant-avatar ant-avatar-circle ant-avatar-image ant-avatar-icon">
						<div class="email-initial-setup-owner">
							{{getInitial(workspaceName)}}
						</div>
					</span>
				</div>
				<button style="padding:8px;">
					<div class="main-title-workspace">
						{{workspaceName}}
					</div>
					<span class="drop-down-option">
						 <span class="src-components">
							 <svg *ngIf="userRole == 'Owner' || userRole == 'Admin';" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
							 <path d="M4 7L8.24264 11.2426L12.4853 7" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
							 </svg>

							 <svg *ngIf="userRole == 'Member' && workspaces.length > 1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
							 <path d="M4 7L8.24264 11.2426L12.4853 7" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
							 </svg>
						</span>
					</span>
				</button>
			</div>

			<div id="WS-dropdown" class="dropdown-menu DAM-drop-down" aria-labelledby="create-workspace">
				<div class="switch-area-section">
					<small class="text-muteds switch-workspaces">Switch Workspace</small>
					<div class="workspace-names" *ngFor="let workspace of workspaces"
					 (click)="selectWorkspace(workspace.id, workspace.title, workspace.role)">
					 <div class="user-img">
						<span *ngIf="workspaceName === workspace.title" class="ant-avatar-selected ant-avatar-circle ant-avatar-image ant-avatar-icon">
							<svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M1 5L4.58824 9L13 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
						</span>
						<span *ngIf="workspaceName != workspace.title" class="ant-avatar ant-avatar-circle ant-avatar-image ant-avatar-icon">
							<div class="email-initial-setup-owner">
								{{getInitial(workspace.title)}}
							</div>
						</span>
					</div>
					<div class="workspace-members-count">
						<a href="javascript:;" class="workspace-list">{{workspace.title}}</a>
						<a href="javascript:;" class="member-list" *ngIf="workspace.member === 1">{{workspace.member}} member</a>
						<a href="javascript:;" class="member-list" *ngIf="workspace.member > 1">{{workspace.member}} members</a>
					</div>
					</div>
				</div>
					<div class="text-muted font-italic px-4 py-2 text-muted" *ngIf="userRole == 'Owner' || userRole == 'Admin'">
						<button class="create-workspace-btn-disable ant-btn" *ngIf="workspaceCountAllowed == totalWorkspaceCreated" (click)="newCrafttorDummy()">
							<a>Create Workspace</a></button>
						<button class="create-workspace-btn ant-btn" *ngIf="workspaceCountAllowed != totalWorkspaceCreated" (click)="newCrafttor()">
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M12 6V18" stroke="#2D7CFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M6.3158 12H17.6842" stroke="#2D7CFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
							<a>Create Workspace</a></button>
					</div>
					<div class="" *ngIf="userRole == 'Owner' || userRole == 'Admin'">
						<div class="workspace-quota" *ngIf="workspaceCountAllowed == totalWorkspaceCreated">
							<p>Limit Reached <span class="workspace-limit-reached" (click)="showUpgradePlans()">Upgrade</span></p>
						</div>
					</div>
			</div>

			<div class="lib-icon-sec" mat-raised-button #tooltip="matTooltip"
			matTooltip="Library"
			matTooltipPosition="below"
			matTooltipClass="custom-tooltip" (click)="goToLibrary()">
				<img src="assets/img/lib-icon.svg">
			</div>

		</div>
		<form class="custom-form search-area-field" (ngSubmit)="onSubmit()" #heroForm="ngForm">
		<div class="center-header">
			<div class="search-box" id="search-box">
				<button>
					<span role="img" aria-label="search" class=""><svg viewBox="64 64 896 896" focusable="false" class="" data-icon="search" width="24px" height="24px" fill="#888888" aria-hidden="true"><path d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"></path></svg></span>
				</button>

				<div class="mat-chip-main" *ngIf="searchTerms.length > 0">
					<ul class="mat-chip-list-main">
						<li class="mat-chip-list" *ngFor="let term of searchTerms; let i = index">
							<span class="chip-txt"><a>{{ term }}</a>
								<span (click)="removeSearchTerm(i, term)" role="img" aria-label="close" tabindex="-1" class="anticon anticon-close ant-tag-close-icon">
									<svg viewBox="64 64 896 896" focusable="false" data-icon="close" width="1em" height="1em" fill="#a9a9a9" aria-hidden="true">
										<path d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z">
										</path>
									</svg>
								</span>
							</span>
						</li>
					</ul>
				</div>

				<input type="text" placeholder="Type here to search by title, tags..." class="text-field" name="searchText" [(ngModel)]="searchText"/>
				<input style="display: none" type="Submit" value="Search" class="button">
			</div>
		</div>
		</form>
		<div class="right-header">

			<div class="menu-pop-over anticon-bell">
				<a href="javascript:;" class="upgrade-txt" (click)="showUpgradePlans()" *ngIf="userRole == 'Owner' || userRole == 'Admin'">Upgrade</a>


				<!-- <button id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
					<span role="img" aria-label="bell" class="">Upgrade</span>
				</button> -->
				<!-- <div class="dropdown-menu" aria-labelledby="notification-pop-over">
						<div class="dropdown-container">
							<div class="item">No new Notification</div>
					</div>
				</div> -->
			</div>

			<div class="figma-icons-section">
        <div class="plugin-figma-icon">
          <button (click)="openFigma()" id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
            <img src="assets/img/ic-figma.png">
          </button>
        </div>

        <div class="plugin-sketch-icon">
          <button (click)="openSketch()" id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
            <img src="assets/img/ic-sketch.png">
          </button>
        </div>

        <div class="plugin-ai-icon">
          <button (click)="openIllustrator()" id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
            <img src="assets/img/ai.png" style="width: 20px; height: 20px;">
          </button>
        </div>
      </div>

			<div class="menu-pop-over anticon-bell">
				<button id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon" (click)="getNotifications()">
					<img src="assets/img/ic-noti.svg">
				</button>
				<!-- <span class="dot"></span> -->
				<div class="dropdown-menu notification-area" aria-labelledby="notification-pop-over">
						<div class="dropdown-container">
							<h5 class="notification-txt" style="margin-bottom:20px;"><b>Notifications</b></h5>
							<div class="notification-item">

								<!-- <div class="" *ngIf="showLoader">
									<img src="assets/img/loader.svg" style="margin-left: auto;margin-right: auto;display: block;width: 30%;" alt="">
								</div> -->

								<div *ngIf="notifications.length == 0" class="empty-notification-area">
									<img src="assets/img/no-noti.svg" alt="">
									<span>You have no notifications</span>
								</div>

								<ul *ngFor="let noti of notifications" style="padding: 0px;">
									<li style="border-bottom: 1px solid rgba(0,0,0,0.1);padding: 16px 0 16px 0;margin: 0 16px;">
										<div class="user-details-info">
										<div class="user-img">
											<span class="ant-avatar ant-avatar-circle ant-avatar-image ant-avatar-icon" style="width: 40px; height: 40px; line-height: 40px; font-size:18px; font-weight: 500;">
												<div class="email-initial-setup" [style.background-color]="getRandomColor()">
													{{getName(noti.firstName)}}{{getName(noti.lastName)}}
												</div>
											</span>
											</div>
											<div>
												<div class="user-info-name">
													<span>{{noti.message}} <b>{{noti.firstName}} {{noti.lastName}}</b></span>
												</div>
												<div class="" style="margin-top: 4px;">
													<span class="notification-date">{{noti.timestamp.toString().split(".")[0]}}</span>
												</div>
											</div>
										</div>
									</li>
								</ul>
							</div>
					</div>
				</div>
			</div>

			<div class="menu-pop-over user-name" *ngIf="currentUser  && !mobileView">
				<button id="user-pop-over" data-toggle="dropdown" class="user-icon-btn">
					<img *ngIf="!userPic" src="assets/img/user-profile.svg">
					<img *ngIf="userPic" src="{{userPic}}">
				</button>
				<div class="dropdown-menu" aria-labelledby="user-pop-over">
					<div class="dropdown-container">
						<div class="upper-container">
							<div class="name-pro">
								<h6>{{currentUser.firstName+" "+currentUser.lastName}}</h6>
								<span class="pro">
									{{planName}}
								</span>
								<!-- <span class="pro">
									BETA
								</span> -->
							</div>
							<div class="email">{{currentUser.email}}</div>
							<div *ngIf="totalSpaceAllowed <= 1000 && consumedSpaceAllowed <= 1000" class="storage-size">{{consumedSpaceAllowed | number: '1.2-2'}}MB / {{totalSpaceAllowed}}GB</div>
              <div *ngIf="totalSpaceAllowed <= 1000 && consumedSpaceAllowed > 1000" class="storage-size">{{consumedSpaceAllowed/1000 | number: '1.2-2'}}GB / {{totalSpaceAllowed}}GB</div>
							<div *ngIf="totalSpaceAllowed > 1000 && consumedSpaceAllowed > 1000" class="storage-size">{{consumedSpaceAllowed/1000 | number: '1.2-2'}}GB / {{totalSpaceAllowed/1000}}TB</div>
							<!-- <div class="storage-indicator">
								<div class="storage-indicator-color">

								</div>
							</div> -->
							<progress id="file" value="{{consumedSpaceAllowed}}" max="{{totalSpaceAllowedProgress}}"></progress>
						</div>

						<ul class="dropdown-list list-group">
							<div class="hr-line"></div>
							<a routerLink="/my-profile"><li class="list-group-item">My profile</li></a>
							<a (click)="personalClick()"><li class="list-group-item">My content hub</li></a>
							<div class="hr-line"></div>
							<a routerLink="/how-it-works" target="_blank"><li class="list-group-item">How it works</li></a>
							<a routerLink="/home" target="_blank"><li class="list-group-item">Go to Homepage</li></a>
							<a (click)="goToMarketplace()"><li class="list-group-item">Go to Marketplace</li></a>
							<a (click)="goToFeedback()"><li class="list-group-item">Feedback & bugs report</li></a>
							<a routerLink="/faq" target="_blank"><li class="list-group-item">FAQ</li></a>
							<a (click)="goProClick()" *ngIf="planName == 'Free'">
								<li class="list-group-item" style="background-color: var(--primaryColorLightBlue); border-radius: 4px; margin-top: 8px; display: block;"><b style="color: #2d7cff">Upgrade plan:</b><span> You're on the free plan. Upgrade now for unlimited storage, access, members, and more.</span></li>
							</a>
						</ul>
						<div class="logout-btn">
							<button type="button" class="ant-btn" (click)="logOut()"><a>Logout</a></button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</header>

<section *ngIf="newBoardSection">
	<div class="main-container">
		<div class="side-bar hide-sidebar" id="side-bar">
			<div class="left-sticky-bar" id="left-sticky-bar">
				<form class="custom-form search-area-field" (ngSubmit)="onSubmit()" #heroForm="ngForm">
				<div class="side-search-box">
					<div class="search-box-side-bar" id="search-box" style="box-shadow:none">
						<button>
							<span role="img" aria-label="search" class=""><svg viewBox="64 64 896 896" focusable="false" class="" data-icon="search" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"></path></svg></span>
						</button>
						<input type="" name="searchText" placeholder="Search" [(ngModel)]="searchText">
						<input style="display: none" type="Submit" value="Search" class="button">
					</div>
				</div>
				</form>
				<div class="side-bar-list-container">
					<div class="sidebar-list-group">
						<a class="" (click)="mainClick()"><span role="img" aria-label="appstore" class="anticon anticon-appstore">
							<img src="assets/img/all-boards.svg" alt="">
						</span>All Boards</a>

						<a class="" (click)="peopleClick()"><span role="img" aria-label="appstore" class="anticon anticon-appstore">
							<img src="assets/img/people.svg" alt="">
						</span>People</a>

						<a class="" (click)="personalClick()" *ngIf="favouriteImagesList.length > 0"><span role="img" aria-label="appstore" class="anticon anticon-appstore">
              <img src="assets/img/star-fav.svg" alt="">
            </span>Favourite</a>
					</div>
					<div class="sidebar-list-group">
						<div class="add-boards">
							<h5 class="active-board">BOARDS</h5>
							<button *ngIf="showLoaderBoardsList"><span role="img" aria-label="plus-circle" class="anticon anticon-plus-circle">
								<img class="img-up-loader-boards" src="assets/img/img-up.svg" alt="">
							</span></button>
							<button (click)="newBoardClick()" mat-raised-button #tooltip="matTooltip"
							matTooltip="Create new board"
							matTooltipPosition="above"
							matTooltipClass="custom-tooltip"><span role="img" aria-label="plus-circle" class="anticon anticon-plus-circle">
								<img src="assets/img/create-board.svg" alt="">
							</span></button>
						</div>
						<ul class="list-group main-boards-list">
							<li *ngFor="let board of boards; let i = index" [ngClass]="{'selected-color' : i==selectedIndex}" style="padding-left: 5px; border-radius: 5px;">
								<a (click)="boardlistClickNew(board.title, board.id); changeColors(i)">{{ board.title }}
									<img src="assets/img/pin-fill.svg" *ngIf="board.is_pin == true">
									<button class="new-board-asset" *ngIf="board.status != ''"><strong>{{ board.status }}</strong></button>
									<button *ngIf="userRole == 'Member' && board.verified == false" class="new-3d">Unverified</button>
								</a>
								<button class="board-option delete-edit-btn" data-toggle="dropdown">
									<svg viewBox="64 64 896 896" focusable="false" class="" data-icon="ellipsis" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z"></path></svg>
								</button>
								<div class="dropdown-menu border-shadow border-radius-5">
									<ul class="list-group border-radius-5">
										<li class="board-list-option"  (click)="pinBoard(board.id)" *ngIf="board.is_pin == false">
											<img class="pin-board" src="assets/img/pin-board-black.svg" alt="">
											<a class="text dropdown-txt" href="javscript:;">Pin</a></li>
										<li class="board-list-option"  (click)="unPinBoard(board.id)" *ngIf="board.is_pin == true">
											<img class="pin-board" src="assets/img/pin-board-black.svg" alt="">
											<a class="text dropdown-txt" href="javscript:;">Unpin</a></li>
										<li class="board-list-option"  (click)="shareBoard(board.id)">
										 	<img src="assets/img/share-black.svg" alt="" style="margin-right: 8px;">
											<a class="text dropdown-txt" href="javscript:;">Share</a></li>

										<li class="board-list-option"  (click)="openEditBoardNames(board.id, board.title)">
											<img style="width: 20px;" class="pin-board" src="assets/img/edit-icon.svg" alt="">
											<a class="text dropdown-txt" href="javscript:;">Rename</a>
										</li>

										<hr class="more-options-hr">

										<li class="board-list-option"  *ngIf="userRole == 'Member' && board.verified == false" (click)="verifyBoard(board.id)">
											<img class="pin-board" src="assets/img/verify-black.svg" alt="">
											<a class="text dropdown-txt" href="javscript:;">Verify</a>
										</li>

										<li class="board-list-option"  (click)="openDeleteBoardShare(board.id, board.title)">
											<img src="assets/img/delete-red.svg" alt="" style="margin-right: 8px;">
											<a class="text-danger dropdown-txt" href="javscript:;" style="color:#eb1313">Delete</a></li>
									</ul>
								</div>
							</li>
						</ul>
					</div>

					<hr style="width: 90%; margin-left: 0;">

					<div class="inbox-settings">

					<div class="sidebar-list-group inbox-areas" *ngIf="userRole == 'Owner' || userRole == 'Admin'">
						<a href="javascript:;" (click)="inboxClick()" class="sidebar-muted"><span role="img" aria-label="delete" class="anticon anticon-delete">
							<img src="assets/img/inbox.svg" alt="">
					</span>Inbox</a>
					</div>

					<div class="sidebar-list-group inbox-areas" *ngIf="userRole == 'Owner' || userRole == 'Admin'">
						<a href="javascript:;" class="sidebar-muted" (click)="settingsClick()"><span role="img" aria-label="delete" class="anticon anticon-delete">
							<img src="assets/img/settings.svg" alt="">
						</span>Settings</a>
					</div>

					<div class="sidebar-list-group settings-areas" *ngIf="userRole == 'Owner' || userRole == 'Admin'">
						<a href="javascript:;" (click)="archiveClick()" class="sidebar-muted" id="trash-txt"><span role="img" aria-label="delete" class="anticon anticon-delete">
							<img src="assets/img/red-delete-24.svg" alt="">
						</span>Trash
					</a>
				</div>
					</div>
				</div>
			</div>
		</div>

		<div class="center-container">
			<div>
				<div class="homepage-heading">
					<div class="homepage-heading_">
					<div class="homepage-heading-title">
						<div class="new-board-name ant-input-wrapper mt-3">
							<span class="ant-input-wrapper ant-input-group">
								<form class="form-horizontal" [formGroup]="createBoards" (ngSubmit)="createBoard()">
									<input maxlength="50" formControlName="message" placeholder="Enter Board Name" data-test-name="invite-email-input" class="ant-input-invite" type="text" value="" [(ngModel)]="boardname" required>
                </form>

								<span class="ant-input-group-addon">
									<button style="width: 150px;" [disabled]="boardname === ''" data-test-name="send-invite-button" type="button" class="ant-btn-invite ant-btn-default ant-input-search-button" (click)="createBoard()" >
										<span *ngIf="!showLeaveLoader" role="img" aria-label="plus" class="create-board-btn">Create Board</span>
										<span *ngIf="showLeaveLoader" role="img" aria-label="plus" class=""><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></span>
									</button>
								</span></span>
							<span class="text-danger error-text board-error-text" *ngIf="isShowError">{{boardCreateErrorMessage}}</span>
						</div>
						<div id="edit-title-inpu" class="d-none edit-title-inpu">

						</div>
					</div>
					</div>
				</div>
				<div class="no-illus-img new-board-empty-img">
					<img src="assets/img/empty_file_img.svg">
					<div><label>Create board and add files to upload.</label></div>
				</div>
			</div>

			<div class="loader-scenarios" *ngIf="showTopRightLoader">
				<img class="img-up-loader" style="width: 30px;" src="assets/img/img-up.svg" alt="">
			</div>

			<div class="loader-scenarios-success-msgs" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="200" *ngIf="sendSuccessful">
				<span class="ant-avatar-selected">
					<svg width="18" height="14" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M1 5L4.58824 9L13 1" stroke="#0fa636" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
				</span>
				<p>{{successfullMessage}}</p>
			</div>

			<div *ngIf="showGreenLeaveLoader" class="">
				<div class="total-img-count center moved-success-area-loader">
					<img src="assets/img/green-loader.gif" alt="" style="height: 25px;">
				</div>
			</div>

			<div class="loader-scenarios-error-msgs" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="200" *ngIf="sendSuccessfulError">
				<p>{{successfullMessageError}}</p>
			</div>

			<div class="loader-scenarios-error-msgs" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="200" *ngIf="sendSuccessfulErrorMsg">
				<p>{{sendSuccessfulErrorMessage}}</p>
			</div>
		</div>
	</div>
</section>

<section *ngIf="searchImageslistSection">
	<div class="main-container">
		<div class="side-bar hide-sidebar" id="side-bar">
			<div class="left-sticky-bar" id="left-sticky-bar">
				<form class="custom-form search-area-field" (ngSubmit)="onSubmit()" #heroForm="ngForm">
				<div class="side-search-box">
					<div class="search-box-side-bar" id="search-box" style="box-shadow:none">
						<button>
							<span role="img" aria-label="search" class=""><svg viewBox="64 64 896 896" focusable="false" class="" data-icon="search" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"></path></svg></span>
						</button>
						<input type="" name="searchText" placeholder="Search" [(ngModel)]="searchText">
						<input style="display: none" type="Submit" value="Search" class="button">
					</div>
				</div>
				</form>
				<div class="side-bar-list-container">
					<div class="sidebar-list-group">
						<a class="" (click)="mainClick()"><span role="img" aria-label="appstore" class="anticon anticon-appstore">
							<img src="assets/img/all-boards.svg" alt="">
						</span>All Boards</a>

						<a class="" (click)="peopleClick()"><span role="img" aria-label="appstore" class="anticon anticon-appstore">
							<img src="assets/img/people.svg" alt="">
						</span>People</a>

						<a class="" (click)="personalClick()" *ngIf="favouriteImagesList.length > 0"><span role="img" aria-label="appstore" class="anticon anticon-appstore">
              <img src="assets/img/star-fav.svg" alt="">
            </span>Favourite</a>
					</div>
					<div class="sidebar-list-group">
						<div class="add-boards">
							<h5>BOARDS</h5>
							<button *ngIf="showLoaderBoardsList"><span role="img" aria-label="plus-circle" class="anticon anticon-plus-circle">
								<img class="img-up-loader-boards" src="assets/img/img-up.svg" alt="">
							</span></button>
							<button (click)="newBoardClick()" mat-raised-button #tooltip="matTooltip"
							matTooltip="Create new board"
							matTooltipPosition="above"
							matTooltipClass="custom-tooltip"><span role="img" aria-label="plus-circle" class="anticon anticon-plus-circle">
								<img src="assets/img/create-board.svg" alt="">
							</span></button>
						</div>
						<ul class="list-group main-boards-list">
							<li *ngFor="let board of boards; let i = index" style="padding-left: 5px; border-radius: 5px;">
								<a (click)="boardlistClickNew(board.title, board.id); changeColors(i)">{{ board.title }}
									<img src="assets/img/pin-fill.svg" *ngIf="board.is_pin == true">
									<button class="new-board-asset" *ngIf="board.status != ''"><strong>{{ board.status }}</strong></button>
									<button *ngIf="userRole == 'Member' && board.verified == false" class="new-3d">Unverified</button>
								</a>
								<button class="board-option delete-edit-btn" data-toggle="dropdown">
									<svg viewBox="64 64 896 896" focusable="false" class="" data-icon="ellipsis" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z"></path></svg>
								</button>
								<div class="dropdown-menu border-shadow border-radius-5">
									<ul class="list-group border-radius-5">
										<li class="board-list-option"  (click)="pinBoard(board.id)" *ngIf="board.is_pin == false">
											<img class="pin-board" src="assets/img/pin-board-black.svg" alt="">
											<a class="text" href="javscript:;">Pin</a></li>
										<li class="board-list-option"  (click)="unPinBoard(board.id)" *ngIf="board.is_pin == true">
											<img class="pin-board" src="assets/img/pin-board-black.svg" alt="">
											<a class="text" href="javscript:;">Unpin</a></li>
										<li class="board-list-option"  (click)="shareBoard(board.id)">
										 	<img src="assets/img/share-black.svg" alt="" style="margin-right: 8px;">
											<a class="text" href="javscript:;">Share</a></li>

										<li class="board-list-option"  (click)="openEditBoardNames(board.id, board.title)">
											<img style="width: 20px;" class="pin-board" src="assets/img/edit-icon.svg" alt="">
											<a class="text dropdown-txt" href="javscript:;">Rename</a>
										</li>

										<hr class="more-options-hr">

										<li class="board-list-option"  *ngIf="userRole == 'Member' && board.verified == false" (click)="verifyBoard(board.id)">
											<img class="pin-board" src="assets/img/verify-black.svg" alt="">
											<a class="text" href="javscript:;">Verify</a>
										</li>

										<li class="board-list-option"  (click)="openDeleteBoardShare(board.id, board.title)">
											<img src="assets/img/delete-red.svg" alt="" style="margin-right: 8px;">
											<a class="text-danger" href="javscript:;" style="color:#eb1313">Delete</a></li>
									</ul>
								</div>
							</li>
						</ul>
					</div>

					<hr style="width: 90%; margin-left: 0;">

					<div class="inbox-settings">

					<div class="sidebar-list-group inbox-areas" *ngIf="userRole == 'Owner' || userRole == 'Admin'">
						<a href="javascript:;" (click)="inboxClick()" class="sidebar-muted"><span role="img" aria-label="delete" class="anticon anticon-delete">
							<img src="assets/img/inbox.svg" alt="">
					</span>Inbox</a>
					</div>

					<div class="sidebar-list-group inbox-areas" *ngIf="userRole == 'Owner' || userRole == 'Admin'">
						<a href="javascript:;" (click)="settingsClick()" class="sidebar-muted"><span role="img" aria-label="delete" class="anticon anticon-delete">
							<img src="assets/img/settings.svg" alt="">
						</span>Settings</a>
					</div>

					<div class="sidebar-list-group settings-areas" *ngIf="userRole == 'Owner' || userRole == 'Admin'">
						<a href="javascript:;" (click)="archiveClick()" class="sidebar-muted" id="trash-txt"><span role="img" aria-label="delete" class="anticon anticon-delete">
							<img src="assets/img/red-delete-24.svg" alt="">
						</span>Trash
					</a>
				</div>
					</div>
				</div>
			</div>
		</div>

		<div class="center-container">
			<div class="search-heading-title">
				<!-- <h3 *ngIf="imagesList && imagesList?.length != 0">Results for '{{searchData}}'</h3> -->
				<div class="illus-rollup-view row mb-5 mt-2">
					<div class="" *ngFor="let imagess of imagesList; let i = index">
						<ul class="new-board-media-list">
							<li>
								<div class="inner-card">
									<div class="illus-img-container" data-toggle="modal">
										<span *ngIf="imagess.version_count > 1">
											<svg style="width: 18px; position: absolute; background: #333333; border-radius: 4px; padding: 2px;" class="mr-2 h-4 w-4 text-pigeon-200" fill="white" aria-hidden="true" viewBox="0 0 32 32"><path d="M16 29.75a3.06 3.06 0 01-1.52-.4L4 23.49A2 2 0 014 20l2.19-1.22-2.13-1.25a2 2 0 01-1-1.77 2 2 0 011-1.76l1.77-1-1.78-1a2 2 0 010-3.53l10.43-5.83a3.14 3.14 0 013 0l10.46 5.84a2 2 0 010 3.53l-1.77 1L28 14a2 2 0 011 1.76 2 2 0 01-1 1.77l-2.2 1.23L27.94 20a2 2 0 010 3.53l-10.46 5.83a3.09 3.09 0 01-1.48.39zm-7.72-9.87L5 21.71l10.41 5.9a1.12 1.12 0 001.08 0L27 21.77l-3.29-1.87-6.19 3.46a3.07 3.07 0 01-3 0zm.49-2l6.7 3.75a1.12 1.12 0 001.08 0l6.68-3.74L27 15.78l-2.86-1.63-6.61 3.69a3.09 3.09 0 01-3 0l-6.57-3.7L5 15.74l3.72 2.12zM7 11.37l.19.08 8.24 4.65a1.1 1.1 0 001.07 0l7.11-4L27 10.27 16.53 4.39a1.08 1.08 0 00-1.07 0L5 10.22z"></path></svg>
										</span>

										<div class="img-share-comment dropdown">
											<span *ngIf="imagess.is_fav == true" class="anticon img-favourite"><svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
													<g id="Icons/Star/Selected" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
															<path d="M19.9582598,9.79420394 C19.853521,9.47022168 19.5661608,9.24011372 19.2261869,9.20947335 L14.6081582,8.79015196 L12.7820653,4.51600335 C12.6474186,4.20276356 12.3407707,4 12.0000645,4 C11.6593582,4 11.3527103,4.20276356 11.2180636,4.5167358 L9.39197075,8.79015196 L4.77320957,9.20947335 C4.43384607,9.24084615 4.14721826,9.47022168 4.04186909,9.79420394 C3.93651992,10.1181862 4.03381224,10.4735412 4.29053217,10.6975455 L7.78121503,13.758897 L6.7518939,18.2930615 C6.67657475,18.6264434 6.8059723,18.971056 7.08259016,19.1710119 C7.23127532,19.2784363 7.40522961,19.333125 7.58064877,19.333125 C7.73189746,19.333125 7.88192541,19.2923526 8.01657214,19.2117843 L12.0000645,16.8309909 L15.9820919,19.2117843 C16.2734806,19.3870814 16.6407988,19.3710898 16.9168063,19.1710119 C17.1935462,18.9704456 17.3228217,18.6257109 17.2475026,18.2930615 L16.2181814,13.758897 L19.7088643,10.6981559 C19.9655842,10.4735412 20.063609,10.1187965 19.9582598,9.79420394 Z" id="Star" fill="#FFC107" fill-rule="nonzero"></path>
													</g>
											</svg></span>

											<div data-toggle="dropdown" *ngIf="imagess.trashed == true">
												<span class="anticon img-more-options"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
												<circle cx="6" cy="12" r="2" fill="white"/>
												<circle cx="12" cy="12" r="2" fill="white"/>
												<circle cx="18" cy="12" r="2" fill="white"/>
												</svg>
												</span>

											<div class="dropdown-menu images-drop-down" aria-labelledby="dropdownMenuButton" data-toggle="dropdown">
												 <ul class="list-group">
													 <li class="more-option-section" (click)="restoreAssets(imagess.board, imagess.id)">
														 <img src="assets/img/restore-black.svg" alt="">
														 <a class="text" href="javscript:;" style="color:#000">Restore</a>
													 </li>
												 </ul>
											 </div>
										 </div>

											<div data-toggle="dropdown" *ngIf="imagess.trashed == false">
												<span class="anticon img-more-options"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
												<circle cx="6" cy="12" r="2" fill="white"/>
												<circle cx="12" cy="12" r="2" fill="white"/>
												<circle cx="18" cy="12" r="2" fill="white"/>
												</svg>
												</span>

											<div class="dropdown-menu images-drop-down" aria-labelledby="dropdownMenuButton" data-toggle="dropdown">
												 <ul class="list-group">
													 <li class="more-option-section" (click)="openShareLinkStyle(imagess.id, imagess.image)">
														 <img style="margin-top: 2px;" src="assets/img/share-black.svg" alt="">
														 <a class="text" href="javscript:;" style="color:#000; margin-left: -3px;">Share</a>
													 </li>

													 <li *ngIf="imagess.is_fav == false" class="more-option-section" (click)="addSearchFavouriteImage(imagess.id, imagess.title, false)">
														 <img style="margin-left: -4px;" src="assets/img/star-black.svg" alt="">
														 <a class="text" href="javscript:;" style="color:#000">Favourite</a>
													 </li>

													 <li class="more-option-section" *ngIf="boards.length > 1" (click)="openMoveImagesStyleBoard(imagess.id, true, i, imagess.board)">
															<img src="assets/img/move-to.svg" alt="">
														 <a class="text" href="javscript:;"  style="color:#000">Move to</a>
													 </li>
													 <li class="more-option-section" (click)="openAssetRenameDialog(imagess.id, imagess.title, imagess.board, imagess.image)">
															<img src="assets/img/edit-icon.svg" alt="">
														 <a class="text" href="javscript:;" style="color:#000">Rename</a>
													 </li>
													 <li *ngIf="planName != 'Free'"  class="more-option-section" (click)="openEditTagsDialog(imagess.id, imagess.title, imagess.image, imagess.board, imagess.image_format)">
															<img src="assets/img/tag-black.svg" alt="">
														 	<a class="text" href="javscript:;" style="color:#000">Edit tags</a>
													 </li>

													 <hr class="more-options-hr">

													 <li class="more-option-section" (click)="downloadSingleImage(imagess.id, imagess.title, imagess.board)">
														 <img src="assets/img/download-black.svg" alt="">
														 <a class="text" href="javscript:;"  style="color:#000">Download</a>
													 </li>
													 <li class="more-option-section" *ngIf="userRole == 'Member' && imagess.verified == false" (click)="verifyAssets(imagess.id)">
														 <a class="text" href="javscript:;"  style="color:#000">Verify</a>
													 </li>
													 <li class="more-option-section" (click)="archiveSingleSearchImage(imagess.id, i, imagess.board, imagess.title)">
														 <img src="assets/img/delete-red.svg" alt="">
														 <a class="text" href="javscript:;"  style="color:#eb1313">Delete</a>
													 </li>
												 </ul>
											 </div>
										 </div>
										</div>

									<video src={{imagess.image}} *ngIf="imagess.image_format == 'MP4' || imagess.image_format == 'WEBM' || imagess.image_format == 'FLV' || imagess.image_format == 'WMV' || imagess.image_format == 'MOV'" style="height: 184px;" controls></video>
									<img src={{imagess.image}} *ngIf="imagess.image_format == 'PNG' || imagess.image_format == 'JPG'  || imagess.image_format == 'SVG' || imagess.image_format == 'JPEG' || imagess.image_format == 'GIF' || imagess.image_format == 'BMP' || imagess.image_format == 'ICO'"  alt="{{ imagess.title }}" (click)="currentIllus=imagess; boardHeading=imagess.board_title; boardId=imagess.board; openImgSearchDialog(imgSearchModal, i, imagess.current_cover, boardId, currentIllus.id, currentIllus.title)">

									<img src={{imagess.image_jpg}} *ngIf="imagess.image_format == 'WEBP' || imagess.image_format == 'TIFF'" (click)="currentIllus=imagess; boardHeading=imagess.board_title; boardId=imagess.board; openImgSearchDialog(imgSearchModal, i, imagess.current_cover, boardId, currentIllus.id, currentIllus.title)" >

									<img src="assets/img/ai-icon.svg" *ngIf="imagess.image_format == 'AI'" (click)="currentIllus=imagess; boardHeading=imagess.board_title; boardId=imagess.board; openImgSearchDialog(imgSearchModal, i, imagess.current_cover, boardId, currentIllus.id, currentIllus.title)" style="height: 184px;">

									<img src="assets/img/eps-icon.svg" *ngIf="imagess.image_format == 'EPS'" (click)="currentIllus=imagess; boardHeading=imagess.board_title; boardId=imagess.board; openImgSearchDialog(imgSearchModal, i, imagess.current_cover, boardId, currentIllus.id, currentIllus.title)">

									<img src="assets/img/zip-icon.svg" *ngIf="imagess.image_format == 'ZIP'" (click)="currentIllus=imagess; boardHeading=imagess.board_title; boardId=imagess.board; openImgSearchDialog(imgSearchModal, i, imagess.current_cover, boardId, currentIllus.id, currentIllus.title)" style="height: 184px;">

									<img src="assets/img/pages.svg" *ngIf="imagess.image_format == 'PAGES' || imagess.image_format == 'NUMBERS'" (click)="currentIllus=imagess; boardHeading=imagess.board_title; boardId=imagess.board; openImgSearchDialog(imgSearchModal, i, imagess.current_cover, boardId, currentIllus.id, currentIllus.title)" style="height: 184px;">

									<img src="assets/img/xlsx-icon.svg" *ngIf="imagess.image_format == 'XLSX'" (click)="currentIllus=imagess; boardHeading=imagess.board_title; boardId=imagess.board; openImgSearchDialog(imgSearchModal, i, imagess.current_cover, boardId, currentIllus.id, currentIllus.title)"style="height: 184px;">

									<img src="assets/img/doc-icon.svg" *ngIf="imagess.image_format == 'DOCX' || imagess.image_format == 'DOC'" (click)="currentIllus=imagess; boardHeading=imagess.board_title; boardId=imagess.board; openImgSearchDialog(imgSearchModal, i, imagess.current_cover, boardId, currentIllus.id, currentIllus.title)"style="height: 184px;">

									<img src="assets/img/psd.svg" *ngIf="imagess.image_format == 'PSD'"style="height: 184px;">

									<pdf-viewer *ngIf="imagess.image_format == 'PDF'" [src]="imagess.image" style="width: 150px; height: 150px;" [original-size]="true" [render-text]="true" [rotation]="0"
  								[show-all]="true" [fit-to-page]="true" [zoom]="1" [zoom-scale]="'page-width'"
  								[stick-to-page]="true" [external-link-target]="'blank'" [autoresize]="true"
  								[show-borders]="false" class="pdf-viewer" [show-all]="false" (page-rendered)="pageRendered()" (click)="currentIllus=imagess; boardHeading=imagess.board_title; boardId=imagess.board; openImgSearchDialog(imgSearchModal, i, imagess.current_cover, boardId, currentIllus.id, currentIllus.title)"></pdf-viewer>

									<button *ngIf="imagess.trashed == false" class="ill-add-btn" (click)="downloadImage(imagess.id, imagess.title, imagess.board)"><span class="anticon anticon-check"><svg viewBox="64 64 896 896" focusable="false" class="" data-icon="download" width="1em" height="1em" fill="#FFFF00" aria-hidden="true"><path d="M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"></path></svg></span></button>
								</div>

								<div class="hover-style" (click)="currentIllus=imagess; boardHeading=imagess.board_title; boardId=imagess.board; openImgSearchDialog(imgSearchModal, i, imagess.current_cover, boardId, currentIllus.id, currentIllus.title)">
									<div class="title"><b>{{ imagess.title }}</b>
										<br>
										<span *ngIf="imagess.size > 1000">{{imagess.image_format}} - {{ imagess.size/1000 }} MB</span>
										<span *ngIf="imagess.size < 1000">{{imagess.image_format}} - {{ imagess.size }} KB</span>
									</div>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>

			<div *ngIf="imagesList && imagesList?.length == 0" style="text-align: center;" class="no-result-section">
				<h3>No results found</h3>
				<div class="no-illus-img">
					<img src="assets/img/no_result.png">
					<div class="no-result-try-txt">Try to search title, tags etc.. </div>
				</div>
				<br />
				<br />
			</div>

				<div style="width: 100%; text-align: left; color: var(--helperTextGray); font-style: italic; font-size: 11px; margin-left: 10px;"></div>
			</div>
		</div>

		<div class="loader-scenarios" *ngIf="showTopRightLoader">
			<img class="img-up-loader" style="width: 30px;" src="assets/img/img-up.svg" alt="">
		</div>

		<div class="loader-scenarios-success-msgs" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="200" *ngIf="sendSuccessful">
			<span class="ant-avatar-selected">
				<svg width="18" height="14" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M1 5L4.58824 9L13 1" stroke="#0fa636" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
			</span>
			<p>{{successfullMessage}}</p>
		</div>

		<div *ngIf="showGreenLeaveLoader" class="">
			<div class="total-img-count center moved-success-area-loader">
				<img src="assets/img/green-loader.gif" alt="" style="height: 25px;">
			</div>
		</div>

		<div class="loader-scenarios-error-msgs" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="200" *ngIf="sendSuccessfulError">
			<p>{{successfullMessageError}}</p>
		</div>

		<div class="loader-scenarios-error-msgs" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="200" *ngIf="sendSuccessfulErrorMsg">
			<p>{{sendSuccessfulErrorMessage}}</p>
		</div>
	</div>
</section>


<!-- Modal -->
<ng-template #imgSearchModal let-imgSearchModal>
		<div class="modal-dialog modal-dialog-centered svg-modal" role="document">
			<div class="modal-content">
				<div class="modal-body d-flex">
					<div class="svg-preview">
						<div class="modal-sep">
							<button (click)="imgSearchModal.close(); closeDialogDownload(); openReplyBoxes(-1); resetFields()" type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true"><svg width="26px" height="26px" viewBox="0 0 26 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
										<title>Cross</title>
										<g id="Page-1" stroke="none" stroke-width="2" fill="none" fill-rule="evenodd">
												<g id="DAM-Landing-Page-Copy-3" transform="translate(-911.000000, -23.000000)">
														<g id="Cross" transform="translate(912.000000, 24.000000)">
																<rect id="Rectangle" x="0" y="0" width="24" height="24" rx="4"></rect>
																<g id="Group-3" transform="translate(12.000000, 12.000000) rotate(45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round">
																		<line x1="8" y1="0" x2="8" y2="16" id="Path-8"></line>
																		<line x1="8" y1="0.421052632" x2="8" y2="15.5789474" id="Path-8-Copy" transform="translate(8.000000, 8.000000) rotate(-90.000000) translate(-8.000000, -8.000000) "></line>
																</g>
														</g>
												</g>
										</g>
								</svg></span>
							</button>
							<span class="ml-5"></span>
							<span class="svg-details-preview-toggle-btn">
								<ul>
									<li>
										<!-- <button type="button" class="ant-btn" id="svg-details-toggle" ant-click-animating-without-extra-node="true" (click)="hideDialogClick()"> -->
											<span (click)="hideDialogClick()" role="img" aria-label="arrow-right" id="aero-to-toggle" class="anticon anticon-arrow-right"><svg width="25px" height="20px" viewBox="0 0 17 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
													<title>Group 7</title>
													<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
															<g id="DAM-Landing-Page-Copy-3" transform="translate(-916.000000, -75.000000)" fill="#FFFFFF">
																	<g id="Switch-account" transform="translate(912.000000, 72.000000)">
																			<g id="Group-7" transform="translate(4.000000, 3.000000)">
																					<path d="M12.3486,7.8193 L4.6516,7.8193 C4.3756,7.8193 4.1516,7.5953 4.1516,7.3193 C4.1516,7.0433 4.3756,6.8193 4.6516,6.8193 L11.1416,6.8193 L9.0066,4.6843 C8.8116,4.4893 8.8116,4.1733 9.0066,3.9773 C9.2026,3.7823 9.5186,3.7823 9.7136,3.9773 L12.7026,6.9653 C12.8456,7.1083 12.8886,7.3243 12.8106,7.5103 C12.7336,7.6973 12.5506,7.8193 12.3486,7.8193" id="Fill-1"></path>
																					<path d="M7.6401,12.6865 C7.5121,12.6865 7.3841,12.6375 7.2861,12.5405 L4.2981,9.5515 C4.1551,9.4095 4.1121,9.1935 4.1901,9.0065 C4.2671,8.8205 4.4501,8.6985 4.6521,8.6985 L12.3481,8.6985 C12.6251,8.6985 12.8481,8.9215 12.8481,9.1985 C12.8481,9.4745 12.6251,9.6985 12.3481,9.6985 L5.8591,9.6985 L7.9941,11.8325 C8.1891,12.0285 8.1891,12.3445 7.9941,12.5405 C7.8961,12.6375 7.7681,12.6865 7.6401,12.6865" id="Fill-3"></path>
																					<path d="M2.5,1 C1.673,1 1,1.673 1,2.5 L1,14.501 C1,15.327 1.673,16 2.5,16 L14.5,16 C15.327,16 16,15.327 16,14.501 L16,2.5 C16,1.673 15.327,1 14.5,1 L2.5,1 Z M14.5,17 L2.5,17 C1.122,17 0,15.879 0,14.501 L0,2.5 C0,1.121 1.122,0 2.5,0 L14.5,0 C15.879,0 17,1.121 17,2.5 L17,14.501 C17,15.879 15.879,17 14.5,17 L14.5,17 Z" id="Fill-5"></path>
																			</g>
																	</g>
															</g>
													</g>
											</svg></span>
										<!-- </button> -->
									</li>
									<li>

									</li>
								</ul>
							</span>
							<div class="svg-preview-container" *ngIf="!showSmallImg">
								<span *ngIf="imagesList.length > 1 && showSearchPreviosIcon" aria-hidden="true" (click)="previousSearchImage(currentSearchIllusPosition)" class="previos-icon">
									<svg style="transform: rotate(180deg);" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M13 23.1421L20.0711 16.071L13 8.99995" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
								</span>

								<input type="checkbox" id="zoomCheck" style="display: none;">
								<label for="zoomCheck">
									<img [src]="currentIllus.image" alt="download illustrations" *ngIf="currentIllus.image_format == 'PNG' || currentIllus.image_format == 'JPG'  ||currentIllus.image_format == 'SVG' || currentIllus.image_format == 'JPEG' || currentIllus.image_format == 'GIF' || currentIllus.image_format == 'BMP' || currentIllus.image_format == 'ICO'">
									<img [src]="currentIllus.image_jpg" *ngIf="currentIllus.image_format == 'WEBP' || currentIllus.image_format == 'TIFF'">

									<img src="assets/img/ai-icon.svg" *ngIf="currentIllus.image_format == 'AI'">

									<img src="assets/img/eps-icon.svg" *ngIf="currentIllus.image_format == 'EPS'">

									<img src="assets/img/zip-icon.svg" *ngIf="currentIllus.image_format == 'ZIP'">

									<img src="assets/img/pages.svg" *ngIf="currentIllus.image_format == 'PAGES' || currentIllus.image_format == 'NUMBERS'">

									<img src="assets/img/doc-icon.svg" *ngIf="currentIllus.image_format == 'DOCX' || currentIllus.image_format == 'DOC'">

									<img src="assets/img/xlsx-icon.svg" *ngIf="currentIllus.image_format == 'XLSX'">

									<img src="assets/img/psd.svg" type="application/pdf" *ngIf="currentIllus.image_format == 'PSD'">
								</label>

								<video src={{currentIllus.image}} *ngIf="currentIllus.image_format == 'MP4' || currentIllus.image_format == 'WEBM' || currentIllus.image_format == 'FLV' || currentIllus.image_format == 'WMV' || currentIllus.image_format == 'MOV'" style="height: 184px;" controls></video>

								<pdf-viewer *ngIf="currentIllus.image_format == 'PDF'" [src]="currentIllus.image" [original-size]="true" [render-text]="true" [rotation]="0"
								[show-all]="true" [fit-to-page]="true" [zoom]="1" [zoom-scale]="'page-width'"
								[stick-to-page]="true" [external-link-target]="'blank'" [autoresize]="true"
								[show-borders]="false" class="pdf-viewer" [show-all]="false" (page-rendered)="pageRendered()"></pdf-viewer>

								<span *ngIf="imagesList.length > 1 && showSearchNextIcon" class="next-icon" aria-hidden="true" (click)="nextSearchImage(currentSearchIllusPosition)">
									<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M13 23.1421L20.0711 16.071L13 8.99995" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
								</span>
							</div>

							<div class="svg-preview-container-small" *ngIf="showSmallImg">
								<span *ngIf="imagesList.length > 1 && showSearchPreviosIcon" aria-hidden="true" (click)="previousSearchImage(currentSearchIllusPosition)" class="previos-icon">
									<svg style="transform: rotate(180deg);" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M13 23.1421L20.0711 16.071L13 8.99995" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
								</span>

								<img [src]="currentIllus.image" alt="download illustrations" *ngIf="currentIllus.image_format == 'PNG' || currentIllus.image_format == 'JPG'  ||currentIllus.image_format == 'SVG' || currentIllus.image_format == 'JPEG' || currentIllus.image_format == 'GIF' || currentIllus.image_format == 'BMP' || currentIllus.image_format == 'ICO'">

								<img [src]="currentIllus.image_jpg" *ngIf="currentIllus.image_format == 'WEBP' || currentIllus.image_format == 'TIFF'">

								<img src="assets/img/ai-icon.svg" *ngIf="currentIllus.image_format == 'AI'">

								<img src="assets/img/eps-icon.svg" *ngIf="currentIllus.image_format == 'EPS'">

								<img src="assets/img/zip-icon.svg" *ngIf="currentIllus.image_format == 'ZIP'">

								<img src="assets/img/pages.svg" *ngIf="currentIllus.image_format == 'PAGES' || currentIllus.image_format == 'NUMBERS'">

								<img src="assets/img/doc-icon.svg" *ngIf="currentIllus.image_format == 'DOCX' || currentIllus.image_format == 'DOC'">

								<img src="assets/img/xlsx-icon.svg" *ngIf="currentIllus.image_format == 'XLSX'">

								<video src={{currentIllus.image}} *ngIf="currentIllus.image_format == 'MP4' || currentIllus.image_format == 'WEBM' || currentIllus.image_format == 'FLV' || currentIllus.image_format == 'WMV' || currentIllus.image_format == 'MOV'" style="height: 184px;" controls></video>

								<img src="assets/img/psd.svg" type="application/pdf" *ngIf="currentIllus.image_format == 'PSD'">

								<pdf-viewer *ngIf="currentIllus.image_format == 'PDF'" [src]="currentIllus.image" [original-size]="true" [render-text]="true" [rotation]="0"
								[show-all]="true" [fit-to-page]="true" [zoom]="1" [zoom-scale]="'page-width'"
								[stick-to-page]="true" [external-link-target]="'blank'" [autoresize]="true"
								[show-borders]="false" class="pdf-viewer" [show-all]="false" (page-rendered)="pageRendered()"></pdf-viewer>

								<span *ngIf="imagesList.length > 1 && showSearchNextIcon" class="next-icon" aria-hidden="true" (click)="nextSearchImage(currentSearchIllusPosition)">
									<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M13 23.1421L20.0711 16.071L13 8.99995" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
								</span>
							</div>

							<div *ngIf="currentIllus.trashed == false && showSmallImg && planName != 'Free'" class="version-img">
								<b>VERSIONS</b>
								<button (click)="closeVersionImages()" type="button" class="close" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true"><svg width="26px" height="26px" viewBox="0 0 26 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
											<title>Cross</title>
											<g id="Page-1" stroke="none" stroke-width="2" fill="none" fill-rule="evenodd">
													<g id="DAM-Landing-Page-Copy-3" transform="translate(-911.000000, -23.000000)">
															<g id="Cross" transform="translate(912.000000, 24.000000)">
																	<rect id="Rectangle" x="0" y="0" width="24" height="24" rx="4"></rect>
																	<g id="Group-3" transform="translate(12.000000, 12.000000) rotate(45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round">
																			<line x1="8" y1="0" x2="8" y2="16" id="Path-8"></line>
																			<line x1="8" y1="0.421052632" x2="8" y2="15.5789474" id="Path-8-Copy" transform="translate(8.000000, 8.000000) rotate(-90.000000) translate(-8.000000, -8.000000) "></line>
																	</g>
															</g>
													</g>
											</g>
									</svg></span>
								</button>


								<!-- <input type="file" accept="pdf/* && image/* && video/*" multiple (change)="selectFilesVersion($event, currentIllusPosition, boardHeading, currentIllus.board, currentIllus.id)" #fileInput> -->
								<button (click)="showUploadReplaceDialog()" type="button" class="close" data-dismiss="modal" aria-label="Close">
									<label for="" style="transform: rotate(45deg); margin-right: 10px;">
										<span aria-hidden="true">
											<svg style="cursor: pointer;" width="26px" height="26px" viewBox="0 0 26 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
												<title>Add</title>
												<g id="Page-1" stroke="none" stroke-width="2" fill="none" fill-rule="evenodd">
														<g id="DAM-Landing-Page-Copy-3" transform="translate(-911.000000, -23.000000)">
																<g id="Cross" transform="translate(912.000000, 24.000000)">
																		<rect id="Rectangle" x="0" y="0" width="24" height="24" rx="4"></rect>
																		<g id="Group-3" transform="translate(12.000000, 12.000000) rotate(45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round">
																				<line x1="8" y1="0" x2="8" y2="16" id="Path-8"></line>
																				<line x1="8" y1="0.421052632" x2="8" y2="15.5789474" id="Path-8-Copy" transform="translate(8.000000, 8.000000) rotate(-90.000000) translate(-8.000000, -8.000000) "></line>
																		</g>
																</g>
														</g>
												</g>
										</svg></span>
									</label>
								</button>


								<!-- <span style="color: #e4e4e4;">Cover</span> -->

								<div class="" style="width: 94%; display: flex;">

									<div (click)="setMainImage(currentIllus.image_v5, 'v5')" *ngIf="currentIllus.image_v5 != null" class="version-card">

										<img *ngIf="currentIllus.v5_format == 'png' || currentIllus.v5_format == 'jpeg' || currentIllus.v5_format == 'jpg' || currentIllus.v5_format == 'svg' || currentIllus.v5_format == 'gif' || currentIllus.v5_format == 'bmp' || currentIllus.v5_format == 'webp' || currentIllus.v5_format == 'WEBP' || currentIllus.v5_format == 'PNG' || currentIllus.v5_format == 'JPEG' || currentIllus.v5_format == 'JPG' || currentIllus.v5_format == 'SVG' || currentIllus.v5_format == 'GIF' || currentIllus.v5_format == 'BMP'" src={{currentIllus.image_v5}}>

										<img src="assets/img/placeholder.png" *ngIf="currentIllus.v5_format == 'ai' || currentIllus.v5_format == 'tiff' || currentIllus.v5_format == 'eps' || currentIllus.v5_format == 'EPS' || currentIllus.v5_format == 'AI' || currentIllus.v5_format == 'TIFF'"  alt="download illustrations">

										<img *ngIf="currentIllus.v5_format == 'psd' || currentIllus.v5_format == 'PSD'" src="assets/img/psd.svg">

										<video src={{currentIllus.image_v5}} *ngIf="currentIllus.v5_format == 'mp4' || currentIllus.v5_format == 'webm' || currentIllus.v5_format == 'flv' || currentIllus.v5_format == 'wmv' || currentIllus.v5_format == 'mov' || currentIllus.v5_format == 'MP4' || currentIllus.v5_format == 'WEBM' || currentIllus.v5_format == 'FLV' || currentIllus.v5_format == 'WMV' || currentIllus.v5_format == 'MOV'" controls></video>

										<pdf-viewer style="width: auto; height: 75px;" *ngIf="currentIllus.v5_format == 'pdf' || currentIllus.v5_format == 'PDF'" [src]="currentIllus.image_v5" [original-size]="true" [render-text]="true" [rotation]="0"
										[show-all]="true" [fit-to-page]="true" [zoom]="1" [zoom-scale]="'page-width'"
										[stick-to-page]="true" [external-link-target]="'blank'" [autoresize]="true"
										[show-borders]="false" class="pdf-viewer" [show-all]="false" (page-rendered)="pageRendered()"></pdf-viewer>

										<b>{{currentIllus.v5_title}}</b>
										<p>{{currentIllus.v5_uploaded_on}}</p>
										<p *ngIf="currentIllus.current_cover == 'v5'" style="color: #2c85ed; font-weight: 700; font-size: 12px">COVER</p>
										<div class="current-version">
											<p>V5</p>
										</div>

										<div class="img-version-dots dropdown">
											<div class="three-dost-version" class="three-dost-version" data-toggle="dropdown">
											<span class="anticon img-more-options"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<circle cx="6" cy="12" r="2" fill="white"/>
											<circle cx="12" cy="12" r="2" fill="white"/>
											<circle cx="18" cy="12" r="2" fill="white"/>
											</svg>
											</span>

											<div class="dropdown-menu version-more-options" aria-labelledby="dropdownMenuButton" data-toggle="dropdown">
												 <ul class="list-group">
													 <li class="">
														 <label class="ml-2 mb-0" style="color:#000" (click)="makeSearchCoverImageVersion(currentSearchIllusPosition, 'v5', currentIllus.board, currentIllus.id)">Make cover version</label>
													 </li>
													 <li class="" (click)="deleteSearchImageVersion(currentSearchIllusPosition, 'v5', currentIllus.board, currentIllus.id)"
													 *ngIf="currentIllus.current_cover != 'v5'">
														 <label class="ml-2 mb-0" style="color:#000">Remove from stack</label>
													 </li>
													 <li class="" (click)="downloadVersionImage(currentIllus.id, currentIllus.title, currentIllus.board, 'v5')">
														 <label class="ml-2 mb-0" style="color:#000">Download version</label>
													 </li>
												 </ul>
											 </div>
										 </div>
										</div>
									</div>

									<div (click)="setMainImage(currentIllus.image_v4, 'v4')" *ngIf="currentIllus.image_v4 != null" class="version-card">

										<img *ngIf="currentIllus.v4_format == 'png' || currentIllus.v4_format == 'jpeg' || currentIllus.v4_format == 'jpg' || currentIllus.v4_format == 'svg' || currentIllus.v4_format == 'gif' || currentIllus.v4_format == 'bmp' || currentIllus.v4_format == 'webp' || currentIllus.v4_format == 'WEBP' || currentIllus.v4_format == 'PNG' || currentIllus.v4_format == 'JPEG' || currentIllus.v4_format == 'JPG' || currentIllus.v4_format == 'SVG' || currentIllus.v4_format == 'GIF' || currentIllus.v4_format == 'BMP'" src={{currentIllus.image_v4}}>

										<img src="assets/img/placeholder.png" *ngIf="currentIllus.v4_format == 'ai' || currentIllus.v4_format == 'tiff' || currentIllus.v4_format == 'eps' || currentIllus.v4_format == 'EPS' || currentIllus.v4_format == 'AI' || currentIllus.v4_format == 'TIFF'"  alt="download illustrations">

										<img *ngIf="currentIllus.v4_format == 'psd' || currentIllus.v4_format == 'PSD'" src="assets/img/psd.svg">

										<video src={{currentIllus.image_v4}} *ngIf="currentIllus.v4_format == 'mp4' || currentIllus.v4_format == 'webm' || currentIllus.v4_format == 'flv' || currentIllus.v4_format == 'wmv' || currentIllus.v4_format == 'mov' || currentIllus.v4_format == 'MP4' || currentIllus.v4_format == 'WEBM' || currentIllus.v4_format == 'FLV' || currentIllus.v4_format == 'WMV' || currentIllus.v4_format == 'MOV'" controls></video>

										<pdf-viewer *ngIf="currentIllus.v4_format == 'pdf' || currentIllus.v4_format == 'PDF'" [src]="currentIllus.image_v4" [original-size]="true" [render-text]="true" [rotation]="0"
										[show-all]="true" [fit-to-page]="true" [zoom]="1" [zoom-scale]="'page-width'"
										[stick-to-page]="true" [external-link-target]="'blank'" [autoresize]="true"
										[show-borders]="false" class="pdf-viewer" [show-all]="false" (page-rendered)="pageRendered()"></pdf-viewer>

										<b>{{currentIllus.v4_title}}</b>
										<p>{{currentIllus.v4_uploaded_on}}</p>
										<p *ngIf="currentIllus.current_cover == 'v4'" style="color: #2c85ed; font-weight: 700; font-size: 12px">COVER</p>
										<div class="current-version">
											<p>V4</p>
										</div>

										<div class="img-version-dots dropdown">
											<div class="three-dost-version" class="three-dost-version" data-toggle="dropdown">
											<span class="anticon img-more-options"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<circle cx="6" cy="12" r="2" fill="white"/>
											<circle cx="12" cy="12" r="2" fill="white"/>
											<circle cx="18" cy="12" r="2" fill="white"/>
											</svg>
											</span>

											<div class="dropdown-menu version-more-options" aria-labelledby="dropdownMenuButton" data-toggle="dropdown">
												 <ul class="list-group">
													 <li class="" *ngIf="currentIllus.current_cover != 'v4'">
														 <label class="ml-2 mb-0" style="color:#000" (click)="makeSearchCoverImageVersion(currentSearchIllusPosition, 'v4', currentIllus.board, currentIllus.id)">Make cover version</label>
													 </li>
													 <li class="" (click)="deleteSearchImageVersion(currentSearchIllusPosition, 'v4', currentIllus.board, currentIllus.id)"
													 *ngIf="currentIllus.current_cover != 'v4'">
														 <label class="ml-2 mb-0" style="color:#000">Remove from stack</label>
													 </li>
													 <li class="" (click)="downloadVersionImage(currentIllus.id, currentIllus.v4_title, currentIllus.board, 'v4')">
														 <label class="ml-2 mb-0" style="color:#000">Download version</label>
													 </li>
												 </ul>
											 </div>
										 </div>
										</div>
									</div>

									<div (click)="setMainImage(currentIllus.image_v3, 'v3')" *ngIf="currentIllus.image_v3 != null" class="version-card">

										<img *ngIf="currentIllus.v3_format == 'png' || currentIllus.v3_format == 'jpeg' || currentIllus.v3_format == 'jpg' || currentIllus.v3_format == 'svg' || currentIllus.v3_format == 'gif' || currentIllus.v3_format == 'bmp' || currentIllus.v3_format == 'webp' || currentIllus.v3_format == 'WEBP' || currentIllus.v3_format == 'PNG' || currentIllus.v3_format == 'JPEG' || currentIllus.v3_format == 'JPG' || currentIllus.v3_format == 'SVG' || currentIllus.v3_format == 'GIF' || currentIllus.v3_format == 'BMP'" src={{currentIllus.image_v3}}>

										<img src="assets/img/placeholder.png" *ngIf="currentIllus.v3_format == 'ai' || currentIllus.v3_format == 'tiff' || currentIllus.v3_format == 'eps' || currentIllus.v3_format == 'EPS' || currentIllus.v3_format == 'AI' || currentIllus.v3_format == 'TIFF'"  alt="download illustrations">

										<img *ngIf="currentIllus.v3_format == 'psd' || currentIllus.v3_format == 'PSD'" src="assets/img/psd.svg">

										<video src={{currentIllus.image_v3}} *ngIf="currentIllus.v3_format == 'mp4' || currentIllus.v3_format == 'webm' || currentIllus.v3_format == 'flv' || currentIllus.v3_format == 'wmv' || currentIllus.v3_format == 'mov' || currentIllus.v3_format == 'MP4' || currentIllus.v3_format == 'WEBM' || currentIllus.v3_format == 'FLV' || currentIllus.v3_format == 'WMV' || currentIllus.v3_format == 'MOV'" controls></video>

										<pdf-viewer *ngIf="currentIllus.v3_format == 'pdf' || currentIllus.v3_format == 'PDF'" [src]="currentIllus.image_v3" [original-size]="true" [render-text]="true" [rotation]="0"
										[show-all]="true" [fit-to-page]="true" [zoom]="1" [zoom-scale]="'page-width'"
										[stick-to-page]="true" [external-link-target]="'blank'" [autoresize]="true"
										[show-borders]="false" class="pdf-viewer" [show-all]="false" (page-rendered)="pageRendered()"></pdf-viewer>
										<b>{{currentIllus.v3_title}}</b>
										<p>{{currentIllus.v3_uploaded_on}}</p>
										<p *ngIf="currentIllus.current_cover == 'v3'" style="color: #2c85ed; font-weight: 700; font-size: 12px">COVER</p>
										<div class="current-version">
											<p>V3</p>
										</div>

										<div class="img-version-dots dropdown">
											<div id="dropdownMenuButton" class="three-dost-version" class="three-dost-version" data-toggle="dropdown">
											<span class="anticon img-more-options"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<circle cx="6" cy="12" r="2" fill="white"/>
											<circle cx="12" cy="12" r="2" fill="white"/>
											<circle cx="18" cy="12" r="2" fill="white"/>
											</svg>
											</span>

											<div class="dropdown-menu version-more-options" aria-labelledby="dropdownMenuButton" data-toggle="dropdown">
												 <ul class="list-group">
													 <li class="" *ngIf="currentIllus.current_cover != 'v3'">
														 <label class="ml-2 mb-0" style="color:#000" (click)="makeSearchCoverImageVersion(currentSearchIllusPosition, 'v3', currentIllus.board, currentIllus.id)">Make cover version</label>
													 </li>
													 <li class="" (click)="deleteSearchImageVersion(currentSearchIllusPosition, 'v3', currentIllus.board, currentIllus.id)"
													 *ngIf="currentIllus.current_cover != 'v3'">
														 <label class="ml-2 mb-0" style="color:#000">Remove from stack</label>
													 </li>
													 <li class="" (click)="downloadVersionImage(currentIllus.id, currentIllus.v3_title, currentIllus.board, 'v3')">
														 <label class="ml-2 mb-0" style="color:#000">Download version</label>
													 </li>
												 </ul>
											 </div>
										 </div>
										</div>
									</div>

									<div (click)="setMainImage(currentIllus.image_v2, 'v2')" *ngIf="currentIllus.image_v2 != null" class="version-card">

										<img *ngIf="currentIllus.v2_format == 'png' || currentIllus.v2_format == 'jpeg' || currentIllus.v2_format == 'jpg' || currentIllus.v2_format == 'svg' || currentIllus.v2_format == 'gif' || currentIllus.v2_format == 'bmp' || currentIllus.v2_format == 'webp' || currentIllus.v2_format == 'WEBP' || currentIllus.v2_format == 'PNG' || currentIllus.v2_format == 'JPEG' || currentIllus.v2_format == 'JPG' || currentIllus.v2_format == 'SVG' || currentIllus.v2_format == 'GIF' || currentIllus.v2_format == 'BMP'" src={{currentIllus.image_v2}}>

										<img src="assets/img/placeholder.png" *ngIf="currentIllus.v2_format == 'ai' || currentIllus.v2_format == 'tiff' || currentIllus.v2_format == 'eps' || currentIllus.v2_format == 'EPS' || currentIllus.v2_format == 'AI' || currentIllus.v2_format == 'TIFF'"  alt="download illustrations">

										<img *ngIf="currentIllus.v2_format == 'psd' || currentIllus.v2_format == 'PSD'" src="assets/img/psd.svg">

										<video src={{currentIllus.image_v2}} *ngIf="currentIllus.v2_format == 'mp4' || currentIllus.v2_format == 'webm' || currentIllus.v2_format == 'flv' || currentIllus.v2_format == 'wmv' || currentIllus.v2_format == 'mov' || currentIllus.v2_format == 'MP4' || currentIllus.v2_format == 'WEBM' || currentIllus.v2_format == 'FLV' || currentIllus.v2_format == 'WMV' || currentIllus.v2_format == 'MOV'" controls></video>

										<pdf-viewer *ngIf="currentIllus.v2_format == 'pdf' || currentIllus.v2_format == 'PDF'" [src]="currentIllus.image_v2" [original-size]="true" [render-text]="true" [rotation]="0"
										[show-all]="true" [fit-to-page]="true" [zoom]="1" [zoom-scale]="'page-width'"
										[stick-to-page]="true" [external-link-target]="'blank'" [autoresize]="true"
										[show-borders]="false" class="pdf-viewer" [show-all]="false" (page-rendered)="pageRendered()"></pdf-viewer>
										<b>{{currentIllus.v2_title}}</b>
										<p>{{currentIllus.v2_uploaded_on}}</p>
										<p *ngIf="currentIllus.current_cover == 'v2'" style="color: #2c85ed; font-weight: 700; font-size: 12px">COVER</p>
										<div class="current-version">
											<p>V2</p>
										</div>

										<div class="img-version-dots dropdown">
											<div class="three-dost-version" class="three-dost-version" data-toggle="dropdown">
											<span class="anticon img-more-options"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<circle cx="6" cy="12" r="2" fill="white"/>
											<circle cx="12" cy="12" r="2" fill="white"/>
											<circle cx="18" cy="12" r="2" fill="white"/>
											</svg>
											</span>

											<div class="dropdown-menu version-more-options" aria-labelledby="dropdownMenuButton" data-toggle="dropdown">
												 <ul class="list-group">
													 <li class="" *ngIf="currentIllus.current_cover != 'v2'">
														 <label class="ml-2 mb-0" style="color:#000" (click)="makeSearchCoverImageVersion(currentSearchIllusPosition, 'v2', currentIllus.board, currentIllus.id)">Make cover version</label>
													 </li>
													 <li class="" (click)="deleteSearchImageVersion(currentSearchIllusPosition, 'v2', currentIllus.board, currentIllus.id)"
													 *ngIf="currentIllus.current_cover != 'v2'">
														 <label class="ml-2 mb-0" style="color:#000">Remove from stack</label>
													 </li>
													 <li class="" (click)="downloadVersionImage(currentIllus.id, currentIllus.v2_title, currentIllus.board, 'v2')">
														 <label class="ml-2 mb-0" style="color:#000">Download version</label>
													 </li>
												 </ul>
											 </div>
										 </div>
										</div>
									</div>

									<div (click)="setMainImage(currentIllus.image_v1, 'v1')" *ngIf="currentIllus.image_v1 != null" class="version-card">

										<img *ngIf="currentIllus.v1_format == 'png' || currentIllus.v1_format == 'jpeg' || currentIllus.v1_format == 'jpg' || currentIllus.v1_format == 'svg' || currentIllus.v1_format == 'gif' || currentIllus.v1_format == 'bmp' || currentIllus.v1_format == 'webp' || currentIllus.v1_format == 'WEBP' || currentIllus.v1_format == 'PNG' || currentIllus.v1_format == 'JPEG' || currentIllus.v1_format == 'JPG' || currentIllus.v1_format == 'SVG' || currentIllus.v1_format == 'GIF' || currentIllus.v1_format == 'BMP'" src={{currentIllus.image_v1}}>

										<img src="assets/img/placeholder.png" *ngIf="currentIllus.v1_format == 'ai' || currentIllus.v1_format == 'tiff' || currentIllus.v1_format == 'eps' || currentIllus.v1_format == 'EPS' || currentIllus.v1_format == 'AI' || currentIllus.v1_format == 'TIFF'"  alt="download illustrations">

										<img *ngIf="currentIllus.v1_format == 'psd' || currentIllus.v1_format == 'PSD'" src="assets/img/psd.svg">

										<video src={{currentIllus.image_v1}} *ngIf="currentIllus.v1_format == 'mp4' || currentIllus.v1_format == 'webm' || currentIllus.v1_format == 'flv' || currentIllus.v1_format == 'wmv' || currentIllus.v1_format == 'mov' || currentIllus.v1_format == 'MP4' || currentIllus.v1_format == 'WEBM' || currentIllus.v1_format == 'FLV' || currentIllus.v1_format == 'WMV' || currentIllus.v1_format == 'MOV'" controls></video>

										<pdf-viewer *ngIf="currentIllus.v1_format == 'pdf' || currentIllus.v1_format == 'PDF'" [src]="currentIllus.image_v1" [original-size]="true" [render-text]="true" [rotation]="0"
										[show-all]="true" [fit-to-page]="true" [zoom]="1" [zoom-scale]="'page-width'"
										[stick-to-page]="true" [external-link-target]="'blank'" [autoresize]="true"
										[show-borders]="false" class="pdf-viewer" [show-all]="false" (page-rendered)="pageRendered()"></pdf-viewer>
										<b>{{currentIllus.v1_title}}</b>
										<p>{{currentIllus.v1_uploaded_on}}</p>
										<p *ngIf="currentIllus.current_cover == 'v1'" style="color: #2c85ed; font-weight: 700; font-size: 12px">COVER</p>
										<div class="current-version">
											<p>V1</p>
										</div>

										<div class="img-version-dots dropdown">
											<div class="three-dost-version" class="three-dost-version" data-toggle="dropdown">
											<span class="anticon img-more-options"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<circle cx="6" cy="12" r="2" fill="white"/>
											<circle cx="12" cy="12" r="2" fill="white"/>
											<circle cx="18" cy="12" r="2" fill="white"/>
											</svg>
											</span>

											<div class="dropdown-menu version-more-options" aria-labelledby="dropdownMenuButton" data-toggle="dropdown">
												 <ul class="list-group">
													 <li class="" *ngIf="currentIllus.current_cover != 'v1'">
														 <label class="ml-2 mb-0" style="color:#000" (click)="makeSearchCoverImageVersion(currentSearchIllusPosition, 'v1', currentIllus.board, currentIllus.id)">Make cover version</label>
													 </li>
													 <li class="" (click)="deleteSearchImageVersion(currentSearchIllusPosition, 'v1', currentIllus.board, currentIllus.id)"
													 *ngIf="currentIllus.current_cover != 'v1'">
														 <label class="ml-2 mb-0" style="color:#000">Remove from stack</label>
													 </li>
													 <li class="" (click)="downloadVersionImage(currentIllus.id, currentIllus.v1_title, currentIllus.board, 'v1')">
														 <label class="ml-2 mb-0" style="color:#000">Download version</label>
													 </li>
												 </ul>
											 </div>
										 </div>
										</div>
									</div>
								</div>
							</div>

							<div class="version-selection" (click)="openVersionImages()" *ngIf="currentIllus.trashed == false && planName != 'Free' && currentIllus.image_format != 'ZIP'">
								<svg class="stack-icon" style="width: 16px; margin-left: 8px; height: 26px;" class="mr-2 h-4 w-4 text-pigeon-200" fill="white" aria-hidden="true" viewBox="0 0 32 32"><path d="M16 29.75a3.06 3.06 0 01-1.52-.4L4 23.49A2 2 0 014 20l2.19-1.22-2.13-1.25a2 2 0 01-1-1.77 2 2 0 011-1.76l1.77-1-1.78-1a2 2 0 010-3.53l10.43-5.83a3.14 3.14 0 013 0l10.46 5.84a2 2 0 010 3.53l-1.77 1L28 14a2 2 0 011 1.76 2 2 0 01-1 1.77l-2.2 1.23L27.94 20a2 2 0 010 3.53l-10.46 5.83a3.09 3.09 0 01-1.48.39zm-7.72-9.87L5 21.71l10.41 5.9a1.12 1.12 0 001.08 0L27 21.77l-3.29-1.87-6.19 3.46a3.07 3.07 0 01-3 0zm.49-2l6.7 3.75a1.12 1.12 0 001.08 0l6.68-3.74L27 15.78l-2.86-1.63-6.61 3.69a3.09 3.09 0 01-3 0l-6.57-3.7L5 15.74l3.72 2.12zM7 11.37l.19.08 8.24 4.65a1.1 1.1 0 001.07 0l7.11-4L27 10.27 16.53 4.39a1.08 1.08 0 00-1.07 0L5 10.22z"></path></svg>
								<p>
									<b *ngIf="selectedVersion == 'v1'">V1</b>
									<b *ngIf="selectedVersion == 'v2'">V2</b>
									<b *ngIf="selectedVersion == 'v3'">V3</b>
									<b *ngIf="selectedVersion == 'v4'">V4</b>
									<b *ngIf="selectedVersion == 'v5'">V5</b>
								</p>
								<svg *ngIf="showSmallImg" class="lower-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
 							 		<path d="M4 7L8.24264 11.2426L12.4853 7" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
 							 	</svg>
								<svg *ngIf="!showSmallImg" class="upper-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
 							 		<path d="M4 7L8.24264 11.2426L12.4853 7" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
 							 	</svg>
							</div>

					</div>
				</div>

				<div class="svg-details bg-white" id="svg-details-toggle-work" *ngIf="hideDialogSection">
 				<div class="">
 				<div class="modal-sep">
 						<div class="svg-details-div">
 							<button type="button" class="ant-btn border-0 mb-2 ant-btn-ghost ant-btn-icon-only hide-on-bg-scr" id="dismiss-svg-details" ant-click-animating-without-extra-node="false"><span role="img" aria-label="left" class="anticon anticon-left" style="font-size: 16px;"><svg viewBox="64 64 896 896" focusable="false" class="" data-icon="left" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"></path></svg></span></button>

							<div class="" *ngIf="hideEditImageName">
									<h6 class="svg-title" *ngIf="currentIllus.is_fav == false">
										<span class="title img-edit-main-name" (click)="editImageName(currentIllus.board)">{{currentIllus.title | slice:0:24}}{{currentIllus.title.length > 24 ? '...' : ''}}</span>
										<span *ngIf="currentIllus.trashed == false" style="margin-left:10px; cursor:pointer" (click)="addSearchFavouriteImage(currentIllus.id, currentIllus.title, true)" role="img" aria-label="star" class="anticon anticon-star"><svg width="24px" height="24px" style="margin-top:-5px;" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
							    <title>Icons/Star/Unselected</title>
							    <g id="Icons/Star/Unselected" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
							        <path d="M19.9582598,9.79420394 C19.853521,9.47022168 19.5661608,9.24011372 19.2261869,9.20947335 L14.6081582,8.79015196 L12.7820653,4.51600335 C12.6474186,4.20276356 12.3407707,4 12.0000645,4 C11.6593582,4 11.3527103,4.20276356 11.2180636,4.5167358 L9.39197075,8.79015196 L4.77320957,9.20947335 C4.43384607,9.24084615 4.14721826,9.47022168 4.04186909,9.79420394 C3.93651992,10.1181862 4.03381224,10.4735412 4.29053217,10.6975455 L7.78121503,13.758897 L6.7518939,18.2930615 C6.67657475,18.6264434 6.8059723,18.971056 7.08259016,19.1710119 C7.23127532,19.2784363 7.40522961,19.333125 7.58064877,19.333125 C7.73189746,19.333125 7.88192541,19.2923526 8.01657214,19.2117843 L12.0000645,16.8309909 L15.9820919,19.2117843 C16.2734806,19.3870814 16.6407988,19.3710898 16.9168063,19.1710119 C17.1935462,18.9704456 17.3228217,18.6257109 17.2475026,18.2930615 L16.2181814,13.758897 L19.7088643,10.6981559 C19.9655842,10.4735412 20.063609,10.1187965 19.9582598,9.79420394 Z" id="Star" stroke="#888888" fill-rule="nonzero"></path>
							    </g>
							</svg></span></h6>
						</div>

						<form class="custom-form search-area-field edit-img-name-field" (ngSubmit)="editImageNameApi(currentIllus.id, 'searchDialog')" #heroForm="ngForm">
							<div *ngIf="showEditImageName" class="edit-img-input">
								<input type="" name="imageNameEdit" [(ngModel)]="imageNameEdit" value="{{imageHeading}}">
								<input style="display: none" type="Submit" class="button">
								<img src="assets/img/cross.svg" alt="" (click)="closeImageEditField()">
							</div>
						</form>
						<p *ngIf="showEditImageName"><small><span class="error-rename">{{renameErrorMsg}}</span></small></p>

						<div class="" *ngIf="hideEditFavImageName">
								<h6 class="svg-title-fav" *ngIf="currentIllus.is_fav == true">
									<span (click)="editFavImageName(currentIllus.board)" class="title">{{currentIllus.title | slice:0:24}}{{currentIllus.title.length > 24 ? '...' : ''}}</span>
									<span *ngIf="currentIllus.trashed == false" style="margin-left:10px;" role="img" aria-label="star" class="anticon anticon-star"><svg style="margin-top:-5px;" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
							    <title>Icons/Star/Selected</title>
							    <g id="Icons/Star/Selected" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
							        <path d="M19.9582598,9.79420394 C19.853521,9.47022168 19.5661608,9.24011372 19.2261869,9.20947335 L14.6081582,8.79015196 L12.7820653,4.51600335 C12.6474186,4.20276356 12.3407707,4 12.0000645,4 C11.6593582,4 11.3527103,4.20276356 11.2180636,4.5167358 L9.39197075,8.79015196 L4.77320957,9.20947335 C4.43384607,9.24084615 4.14721826,9.47022168 4.04186909,9.79420394 C3.93651992,10.1181862 4.03381224,10.4735412 4.29053217,10.6975455 L7.78121503,13.758897 L6.7518939,18.2930615 C6.67657475,18.6264434 6.8059723,18.971056 7.08259016,19.1710119 C7.23127532,19.2784363 7.40522961,19.333125 7.58064877,19.333125 C7.73189746,19.333125 7.88192541,19.2923526 8.01657214,19.2117843 L12.0000645,16.8309909 L15.9820919,19.2117843 C16.2734806,19.3870814 16.6407988,19.3710898 16.9168063,19.1710119 C17.1935462,18.9704456 17.3228217,18.6257109 17.2475026,18.2930615 L16.2181814,13.758897 L19.7088643,10.6981559 C19.9655842,10.4735412 20.063609,10.1187965 19.9582598,9.79420394 Z" id="Star" fill="#FFC107" fill-rule="nonzero"></path>
							    </g>
							</svg></span></h6>
						</div>

						<form class="custom-form search-area-field edit-img-name-field" (ngSubmit)="editFavImageNameApi(currentIllus.id, 'searchDialog')" #heroForm="ngForm">
							<div *ngIf="showEditFavImageName" class="edit-img-input">
								<input type="" name="favImageNameEdit" [(ngModel)]="favImageNameEdit" value="{{favImageHeading}}">
								<input style="display: none" type="Submit" class="button">
								<img src="assets/img/cross.svg" alt="" (click)="closeImageEditField()">
							</div>
						</form>

						<p *ngIf="showEditFavImageName"><small><span class="error-rename">{{renameErrorMsg}}</span></small></p>

							<p *ngIf="currentIllus.size > 1000"><small><span class="text-muted">{{currentIllus.size/1000}}MB Uploaded by <span style="color: #000000">{{currentIllus.uploaded_by_name}}</span> on <span style="color: #000000">{{currentIllus.uploaded_on}}</span> </span></small></p>

 							<p *ngIf="currentIllus.size < 1000"><small><span class="text-muted">{{currentIllus.size}}KB Uploaded by <span style="color: #000000">{{currentIllus.uploaded_by_name}}</span> on <span style="color: #000000">{{currentIllus.uploaded_on}}</span> </span></small></p>


							<div class="flex mt-3">
								<span class="d-inline-flex">

									<button *ngIf="currentIllus.trashed == true && (currentIllus.image_format == 'PDF' || currentIllus.image_format == 'PSD' || currentIllus.image_format == 'MP4' || currentIllus.image_format == 'WEBM' || currentIllus.image_format == 'FLV' || currentIllus.image_format == 'WMV' || currentIllus.image_format == 'MOV')" type="button" class="ant-btn ant-btn-primary svg-download" data-toggle="dropdown" (click)="imgSearchModal.close(); restoreAssets(currentIllus.board, currentIllus.id)"><span style="text-transform: uppercase;">Restore</span><span> </span></button>

									<button *ngIf="currentIllus.trashed == true && (currentIllus.image_format == 'PNG' || currentIllus.image_format == 'JPG'  ||currentIllus.image_format == 'SVG' || currentIllus.image_format == 'JPEG' || currentIllus.image_format == 'GIF' || currentIllus.image_format == 'BMP' || currentIllus.image_format == 'ICO' || currentIllus.image_format == 'TIFF' || currentIllus.image_format == 'WEBP'  || currentIllus.image_format == 'AI' || currentIllus.image_format == 'EPS' || currentIllus.image_format == 'ZIP')" (click)="imgSearchModal.close(); restoreAssets(currentIllus.board, currentIllus.id)" type="button" class="ant-btn ant-btn-primary" data-toggle="dropdown"><span>Restore</span><span> </span></button>

									<button *ngIf="currentIllus.trashed == false && planName == 'Free' && (currentIllus.image_format == 'PDF' || currentIllus.image_format == 'PSD' || currentIllus.image_format == 'MP4' || currentIllus.image_format == 'WEBM' || currentIllus.image_format == 'FLV' || currentIllus.image_format == 'WMV' || currentIllus.image_format == 'MOV' || currentIllus.image_format == 'ICO')" type="button" class="ant-btn ant-btn-primary svg-download" data-toggle="dropdown" (click)="downloadImage(currentIllus.id, currentIllus.title, currentIllus.board)"><span role="img" aria-label="download" class="anticon anticon-download"><svg viewBox="64 64 896 896" focusable="false" class="" data-icon="download" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"></path></svg></span><span style="text-transform: uppercase;">Download {{currentIllus.image_format}}</span><span> </span></button>

									<button *ngIf="currentIllus.trashed == false && planName == 'Free' && (currentIllus.image_format == 'PNG' || currentIllus.image_format == 'JPG'  ||currentIllus.image_format == 'SVG' || currentIllus.image_format == 'JPEG' || currentIllus.image_format == 'GIF' || currentIllus.image_format == 'BMP' || currentIllus.image_format == 'TIFF' || currentIllus.image_format == 'WEBP' || currentIllus.image_format == 'EPS' || currentIllus.image_format == 'AI' || currentIllus.image_format == 'ZIP')" (click)="downloadImage(currentIllus.id, currentIllus.title, currentIllus.board)" type="button" class="ant-btn ant-btn-primary" data-toggle="dropdown"><span role="img" aria-label="download" class="anticon anticon-download"><svg viewBox="64 64 896 896" focusable="false" class="" data-icon="download" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"></path></svg></span><span>Download {{currentIllus.image_format}}</span><span> </span></button>

									<div class="dropdown" *ngIf="currentIllus.trashed == false && planName != 'Free'">
										<button *ngIf="currentIllus.image_format == 'PDF' || currentIllus.image_format == 'PSD' || currentIllus.image_format == 'MP4' || currentIllus.image_format == 'WEBM' || currentIllus.image_format == 'FLV' || currentIllus.image_format == 'WMV' || currentIllus.image_format == 'MOV' || currentIllus.image_format == 'WEBP' || currentIllus.image_format == 'EPS' || currentIllus.image_format == 'AI' || currentIllus.image_format == 'ZIP' || currentIllus.image_format == 'ICO'" type="button" class="ant-btn ant-btn-primary svg-download" data-toggle="dropdown" (click)="downloadImage(currentIllus.id, currentIllus.title, currentIllus.board)"><span role="img" aria-label="download" class="anticon anticon-download"><svg viewBox="64 64 896 896" focusable="false" class="" data-icon="download" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"></path></svg></span><span style="text-transform: uppercase;">Download {{currentIllus.image_format}}</span><span> </span></button>

										<button *ngIf="currentIllus.image_format == 'PNG' || currentIllus.image_format == 'JPG'  ||currentIllus.image_format == 'SVG' || currentIllus.image_format == 'JPEG' || currentIllus.image_format == 'GIF' || currentIllus.image_format == 'BMP' || currentIllus.image_format == 'TIFF'" (click)="downloadImage(currentIllus.id, currentIllus.title, currentIllus.board)" type="button" class="ant-btn ant-btn-primary svg-download-dialog" data-toggle="dropdown"><span role="img" aria-label="download" class="anticon anticon-download"><svg viewBox="64 64 896 896" focusable="false" class="" data-icon="download" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"></path></svg></span><span>Download {{currentIllus.image_format}}</span><span> </span></button>

										<!-- <button *ngIf="showMainDownloadLoader" type="button" class="ant-btn ant-btn-primary svg-download-dialog" style="width: 135px;"><img src="assets/img/leave-loader.gif" alt="" style="height: 15px;"></button> -->

										<button *ngIf="currentIllus.image_format == 'PNG' || currentIllus.image_format == 'JPG'  ||currentIllus.image_format == 'SVG' || currentIllus.image_format == 'JPEG' || currentIllus.image_format == 'GIF' || currentIllus.image_format == 'BMP' || currentIllus.image_format == 'TIFF'" (click)="showDownloadPopup()" type="button" class="ant-btn ant-btn-primary svg-download-spinner" style="margin-left: 1px;"><span>
											<svg style="transform: rotate(90deg);" width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M13 23.1421L20.0711 16.071L13 8.99995" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
											</svg>
										</span></button>

										<div class="p-3 border-shadow download-asset-format dropdown-menu-right" *ngIf="showDownloadDialog">
										<div class="d-flex">
											<!-- <label style="font-size: 14px;">Filetype</label> -->
											<ul class="list-unstyled d-flex" *ngFor="let formats of imageFormats; let i=index">
												<li style="margin-bottom: 3px; padding: 5px 12px; font-size: 14px; transition: 0.2s all;" [ngClass]="{'selected-color' : i==selectedFormatIndex}">
													<a (click)="getImage(currentIllus.image, formats); changeFormatColors(i)" href="javascript:;">{{formats}}</a>
												</li>
											</ul>
										</div>

										<div class="mt-2">
											<button class="w-100 bg-dark text-white" (click)="downloadFormatImage(currentIllus.id, currentIllus.title, currentIllus.board)" *ngIf="!showDownloadLoader" style="height: 40px;">
												<svg style="margin-right: 5px;" viewBox="64 64 896 896" focusable="false" class="" data-icon="download" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"></path></svg>
											<b>Download as {{imageDownloadShowFormat}}</b></button>

											<button class="w-100 bg-dark text-white" *ngIf="showDownloadLoader" style="height: 40px;"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;">
											</button>
										</div>
									</div>

									</div>
								</span>


								<button *ngIf="currentIllus.trashed == false" type="button" class="ant-btn ant-btn-share-delete" style="margin-left:6px;"  (click)="currentIllus.image; openPopupShare(currentIllus.id)"><span>
									<svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M13 17C14.1046 17 15 16.1046 15 15C15 13.8954 14.1046 13 13 13C11.8954 13 11 13.8954 11 15C11 16.1046 11.8954 17 13 17Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M3 11C4.10457 11 5 10.1046 5 9C5 7.89543 4.10457 7 3 7C1.89543 7 1 7.89543 1 9C1 10.1046 1.89543 11 3 11Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M13 5C14.1046 5 15 4.10457 15 3C15 1.89543 14.1046 1 13 1C11.8954 1 11 1.89543 11 3C11 4.10457 11.8954 5 13 5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M11 4L4.5 8" stroke="black" stroke-width="1.5"/>
									<path d="M4.5 10L11 14" stroke="black" stroke-width="1.5"/>
									</svg>
								</span></button>

								<button type="button" class="ant-btn ant-btn-share-delete" style="margin-left:6px;"  (click)="imgSearchModal.close(); deleteSingleSearchDialogImage(currentIllus.id)"><span>
									<svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M1 4.55469H2.58025H15.2222" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M13.444 5.08889V15.4C13.444 15.8243 13.2835 16.2313 12.9977 16.5314C12.7119 16.8314 12.3243 17 11.9202 17H4.30115C3.89701 17 3.50943 16.8314 3.22366 16.5314C2.93789 16.2313 2.77734 15.8243 2.77734 15.4V5.08889M5.06306 4.2V2.6C5.06306 2.17565 5.2236 1.76869 5.50937 1.46863C5.79514 1.16857 6.18273 1 6.58687 1H9.63449C10.0386 1 10.4262 1.16857 10.712 1.46863C10.9978 1.76869 11.1583 2.17565 11.1583 2.6V4.2" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
								</span></button>
							</div>

							<div class="" style="margin-top: 30px;">
								<ul class="nav nav-tabs" id="myTab" role="tablist">
									<li class="nav-item" role="presentation">
										<button class="nav-link active" id="invite-tab" data-toggle="tab" data-target="#invite" type="button" role="tab" aria-controls="home" aria-selected="true" (click)="openReplyBoxes(-1)">Detail</button>
									</li>
									<li *ngIf="currentIllus.trashed == false && planName != 'Free'" class="nav-item" role="presentation">
										<button class="nav-link" id="team-tab" data-toggle="tab" data-target="#team" type="button" role="tab" aria-controls="team" aria-selected="false" (click)="getAssetsComments(currentIllus.board, currentIllus.id)">Comments</button>
									</li>
								</ul>

						<div class="tab-content" id="myTabContent">
							<div class="tab-pane fade active show" id="invite" role="tabpanel" aria-labelledby="invite-tab" style="margin-top: 16px;">
							<div><small class="font-weight-bold text-muted">Board</small></div>
							<div class="illus-name">
								<ul class="list-unstyled p-0">
									<li><button class="illus-name-btn">{{currentIllus.board_title}}</button></li>
								</ul>
							</div>


							<div class="illus-tag" *ngIf="currentIllus.trashed == false && planName != 'Free'">
								<small class="text-muted">
									<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
									    <title>Icons/Tag</title>
									    <g id="Icons/Tag" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
									        <g id="Group-5" transform="translate(4.000000, 4.000000)">
									            <path d="M8.81251765,0.737788235 L0.738164706,8.81214118 C0.381458824,9.16884706 0.381458824,9.74672941 0.738164706,10.1024941 L5.89769412,15.2620235 C6.25345882,15.6187294 6.83134118,15.6187294 7.18710588,15.2620235 L15.2624,7.18767059 C15.4581647,6.99190588 15.5541647,6.71708235 15.5240471,6.44225882 L15.0082824,1.79755294 C14.9612235,1.37402353 14.6261647,1.03896471 14.2016941,0.991905882 L9.55792941,0.476141176 C9.28310588,0.446023529 9.00828235,0.542023529 8.81251765,0.737788235 Z" id="Stroke-1" stroke="#888888" stroke-linecap="round" stroke-linejoin="round"></path>
									            <path d="M12.5642353,5.37072941 C12.0296471,5.90531765 11.1637647,5.90531765 10.6291765,5.37072941 C10.0945882,4.83614118 10.0945882,3.97025882 10.6291765,3.43567059 C11.1637647,2.90108235 12.0296471,2.90108235 12.5642353,3.43567059 C13.0988235,3.97025882 13.0988235,4.83614118 12.5642353,5.37072941" id="Fill-3" fill="#888888"></path>
									        </g>
									    </g>
									</svg>
									Add Tags</small> <small class="text-muted float-right"><a href="javascript:;" class="text-muted"></a></small>
								<ul class="list-unstyled p-0" >
								<li class="tags-listing">


									<button class="illus-tag-add-btn illus-tag-btn" id="add-tag" (click)="showTagFieldData()" *ngIf="plusButton">
										<span role="img" aria-label="plus" class=""><svg viewBox="64 64 896 896" focusable="false" class="" data-icon="plus" width="1em" height="1em" fill="currentColor" aria-hidden="true"><defs><style></style></defs><path d="M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"></path><path d="M176 474h672q8 0 8 8v60q0 8-8 8H176q-8 0-8-8v-60q0-8 8-8z"></path></svg></span>
									</button>
									<form class="custom-form search-area-field" (ngSubmit)="onSubmitTag(currentIllus.board)" #heroForm="ngForm">
										<input type="text" name="" id="create-tag-input" class="create-tag-input" *ngIf="tagFieldArea" name="addTagText" [(ngModel)]="addTagText">
										<input style="display: none" type="Submit" value="Add" class="button">
									</form>
								</li>
								</ul>

							</div>
							<div class="illus-tag illus-tags-display" *ngIf="currentIllus.trashed == false && planName != 'Free'">
							<small class="text-uppercase text-muted" *ngIf="addedTagList.length > 0 || currentIllus.tags.length > 0">Tags Added</small>
							<div class="image-tags-div">
								<ul class="list-unstyled p-0" *ngFor="let tag of addedTagList; let i=index">
									<li><button class="illus-tag-btn">
											<span class="tags-text-entry"><a href="javscript:;">{{tag.tags}}</a>
												<span (click)="deleteImageTagsList(tag.tags, i)" role="img" aria-label="close" tabindex="-1" class="anticon anticon-close ant-tag-close-icon">
													<svg viewBox="64 64 896 896" focusable="false" data-icon="close" width="1em" height="1em" fill="currentColor" aria-hidden="true">
														<path d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z">
														</path>
													</svg>
												</span>
											</span>
									</button></li>
								</ul>
								</div>

							<div class="image-tags-div main-suggested-tags">
								<ul class="list-unstyled p-0" *ngFor="let tag of currentIllus.tags; let i=index">
									<li><button class="illus-tag-btn">
											<span class="tags-text-entry"><a href="javscript:;">{{tag}}</a>
												<span (click)="deleteImageTags(tag, i)" role="img" aria-label="close" tabindex="-1" class="anticon anticon-close ant-tag-close-icon">
													<svg viewBox="64 64 896 896" focusable="false" data-icon="close" width="1em" height="1em" fill="currentColor" aria-hidden="true">
														<path d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z">
														</path>
													</svg>
												</span>
											</span>
									</button></li>
								</ul>
								</div>

								<small *ngIf="suggestedTags.length > 0" class="text-uppercase text-muted">Suggested Tags</small>
								<div class="image-tags-div">
									<ul class="list-unstyled p-0" *ngFor="let tag of suggestedTags | slice:0:14; let i=index">
										<li><button class="illus-tag-btn" (click)="onSubmitSuggestedTag(tag, currentIllus.board)">
												<span class="tags-text-entry"><a href="javscript:;">{{tag}}</a>
												</span>
										</button></li>
									</ul>
								</div>
							</div>

						</div>

						<div class="tab-pane fade" id="team" role="tabpanel" aria-labelledby="team-tab">
							<div class="comment-filter-icon">
								<div class="" data-toggle="dropdown">
									<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M14.6083 2.64572C15.1579 1.99575 14.6959 1 13.8447 1H2.1553C1.30408 1 0.842074 1.99575 1.39173 2.64573L6.4 8.568V13.182C6.4 13.5607 6.614 13.907 6.95279 14.0764L8.15279 14.6764C8.81769 15.0088 9.6 14.5253 9.6 13.782V8.568L14.6083 2.64572Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
								</div>

								<div class="dropdown-menu" aria-labelledby="dropdownMenu2">

										<a (click)="getUnResolveComments(currentIllus.board, currentIllus.id)" class="dropdown-item" type="button" style="padding-left: 10px">
											Open comments
										</a>

										<a (click)="getAssetsComments(currentIllus.board, currentIllus.id)" class="dropdown-item" type="button" style="padding-left: 10px">
											All comments
										</a>

										<a (click)="resolvedListComments(currentIllus.board, currentIllus.id)" class="dropdown-item" type="button" style="padding-left: 10px;">
											Resolved comments
										</a>
								</div>
							</div>

							<div class="" *ngIf="commentsList.length == 0" style="text-align: center; margin-top:150px">
								<img src="assets/img/lost.png" alt="" style="width: 120px; height: 150px;">
								<p>{{noComments}}</p>
							</div>

							<div #scrollMe style="overflow: scroll; max-height: 100%;" class="svg-details-comments bg-white" id="svg-details-toggle-work">
								<div class="" *ngIf="commentsList.length > 0">
								<div class="modal-sep-">
										<div class="svg-details-div">

											<div class="comments-list-section">
												<ul class="list-unstyled p-0 main-comment-list" style="max-height: 100%;">
													<li *ngFor="let comments of commentsList; let i = index">
														<div class="comment-user-img">
															<img src="assets/img/user-pic.png">
															<div class="comment-date">
																<p>{{comments.firstname}} {{comments.lastname}}</p>
																<p class="date">{{comments.created_date}}</p>
															</div>

															<div class="comment-resolve-icon" (click)="postResolvedComments(currentIllus.board, comments.asset, comments.id)" *ngIf="!comments.is_resolved">
																<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
																<circle cx="10" cy="10" r="9" stroke="#D9D9D9"/>
																<path d="M6 9.90476L7.90476 12.5714L14 8" stroke="#D4D4D4" stroke-width="1.5" stroke-linecap="round"/>
																</svg>
															</div>

															<div class="comment-resolve-icon-resolved" *ngIf="comments.is_resolved">
																<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
																<circle cx="10" cy="10" r="9" stroke="#0fa636"/>
																<path d="M6 9.90476L7.90476 12.5714L14 8" stroke="#0fa636" stroke-width="1.5" stroke-linecap="round"/>
																</svg>
															</div>
															<div class="comment-options-icon">
																<button type="button" name="button" data-toggle="dropdown">
																	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																	<circle cx="12" cy="18" r="2" transform="rotate(-90 12 18)" fill="#a9a9a9"/>
																	<circle cx="12" cy="12" r="2" transform="rotate(-90 12 12)" fill="#a9a9a9"/>
																	<circle cx="12" cy="6" r="2" transform="rotate(-90 12 6)" fill="#a9a9a9"/>
																	</svg>
																</button>

																<div class="dropdown-menu" aria-labelledby="dropdownMenu2">

																		<a class="dropdown-item" type="button" (click)="postResolvedComments(currentIllus.board, comments.asset, comments.id)" style="padding-left: 10px">
																			<svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
																			<circle cx="8" cy="8" r="6" stroke="#D9D9D9"/>
																			<path d="M5.33334 7.93635L6.60318 9.71412L10.6667 6.6665" stroke="#D4D4D4" stroke-width="1.5" stroke-linecap="round"/>
																			</svg>
																			Resolve
																		</a>

																		<!-- <a class="dropdown-item" type="button" (click)="openEditComment()" style="padding-left: 10px">
																			<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
																			<path d="M9.48529 2.41421C10.2663 1.63317 11.5327 1.63317 12.3137 2.41421L12.8794 2.9799C13.6605 3.76095 13.6605 5.02728 12.8794 5.80833L7.04676 11.641C6.97696 11.7108 6.88806 11.7584 6.79126 11.7777L2.69707 12.5966L3.51591 8.50236C3.53526 8.40556 3.58284 8.31666 3.65264 8.24686L9.48529 2.41421Z" stroke="#D4D4D4" stroke-linecap="round" stroke-linejoin="round"/>
																			<path d="M8.63675 3.2627L12.0309 6.65681" stroke="#D4D4D4" stroke-linecap="round"/>
																			</svg>
																			Edit
																		</a> -->

																		<a class="dropdown-item" type="button" (click)="deleteComments(currentIllus.board, comments.asset, comments.id)" style="padding-left: 10px;">
																			<svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
																			<path fill-rule="evenodd" clip-rule="evenodd" d="M11.5088 12.6807H4.4351C4.15569 12.6807 3.92984 12.4548 3.92984 12.1754V4.0912C3.92984 3.8123 4.15569 3.58594 4.4351 3.58594H11.5088C11.7882 3.58594 12.0141 3.8123 12.0141 4.0912V12.1754C12.0141 12.4548 11.7882 12.6807 11.5088 12.6807Z" stroke="#D4D4D4"/>
																			<path d="M6.21535 6.86914L6.20605 10.9112" stroke="#D4D4D4" stroke-linecap="round" stroke-linejoin="round"/>
																			<path d="M9.71272 6.86914L9.70342 10.9112" stroke="#D4D4D4" stroke-linecap="round" stroke-linejoin="round"/>
																			<path d="M13.0246 5.29108H2.91931" stroke="#D4D4D4" stroke-linecap="round"/>
																			</svg>
																			Delete
																		</a>
																</div>
															</div>
														</div>
														<p class="comments">{{comments.comment}}</p>

														<div class="comment-reply-msgs" *ngIf="openEditBox">

															<form class="form-horizontal" [formGroup]="commentForm" (ngSubmit)="editComments(currentIllus.board, comments.asset, comments.id)">

																<input id="textinput" formControlName="comment" maxlength="100" type="text" placeholder="Comment message" class="form-control input-md" required="">

																<svg (click)="editComments(currentIllus.board, comments.asset, comments.id)" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																<rect width="24" height="24" rx="4" fill="#2D7CFF"/>
																<g clip-path="url(#clip0_318_1276)">
																<path d="M18.6667 5.3335L11.3334 12.6668" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
																<path d="M18.6667 5.3335L14 18.6668L11.3334 12.6668L5.33337 10.0002L18.6667 5.3335Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
																</g>
																<defs>
																<clipPath id="clip0_318_1276">
																<rect width="16" height="16" fill="white" transform="translate(4 4)"/>
																</clipPath>
																</defs>
																</svg>
															</form>

														</div>

														<div class="reply-section" *ngIf="comments.reply.length > 0">
															<ul *ngFor="let reply of comments.reply">
																<li>
																	<div class="reply-img">
																		<img src="assets/img/user-pic.png">
																		<div class="reply-date">
																			<p class="comments-reply">{{reply.firstname}} {{reply.lastname}}</p>
																			<p class="date">{{reply.created_date}}</p>
																		</div>
																	</div>
																	<p class="comments-reply">{{reply.comment}}</p>
																</li>
															</ul>
														</div>

														<div class="">
															<div class="comment-reply-msgs" *ngIf="i === index">

																<div class="p-3 border-shadow comments-users-list" *ngIf="showUsersListReplyDialog">
																	 <ul class="list-group">
																		 <li (click)="selectedReplyTagUser(users.user_object.id, users.fullName)" class="" *ngFor="let users of usersList; let i=index">
																			 <div class="comments-user-name">
																				{{getInitial(users.fullName)}}
																			</div>
																			 <label class="ml-2 mb-0" class="comment-user-list-label">{{users.fullName}}</label>
																		 </li>
																	 </ul>
																 </div>

																<form class="form-horizontal" [formGroup]="replyForm" (ngSubmit)="onSubmitReplyComment(currentIllus.id, comments.id, replyData.value, currentIllus.board)">
																	<input id="textinput" formControlName="replyMessage" maxlength="100" type="text" placeholder="Reply message" class="form-control input-md" [(ngModel)]="replyArea" autocomplete="off" (input)="hitUsersListReplyApi($event)" #replyData>

																	<!-- <button style="margin-right: 12px;" (click)="isEmojiPickerVisibleReply = !isEmojiPickerVisibleReply;">😀</button>
																	<br /> -->
																	<emoji-mart [style]="{ position: 'absolute', bottom: '20px', right: '20px'}" class="emoji-mart" *ngIf="isEmojiPickerVisibleReply"
																	(emojiClick)="addReplyEmoji($event)" title="Choose your emoji"></emoji-mart>

																	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="onSubmitReplyComment(currentIllus.id, comments.id, replyData.value, currentIllus.board)">
																	<rect width="24" height="24" rx="4" fill="#2D7CFF"/>
																	<g clip-path="url(#clip0_318_1276)">
																	<path d="M18.6667 5.3335L11.3334 12.6668" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
																	<path d="M18.6667 5.3335L14 18.6668L11.3334 12.6668L5.33337 10.0002L18.6667 5.3335Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
																	</g>
																	<defs>
																	<clipPath id="clip0_318_1276">
																	<rect width="16" height="16" fill="white" transform="translate(4 4)"/>
																	</clipPath>
																	</defs>
																	</svg>
																</form>
															</div>
															<p *ngIf="i !== index" class="reply" (click)="openReplyBoxes(i)">Reply</p>
															<p *ngIf="i === index" class="reply" (click)="openReplyBoxes(-1)">Reply</p>
														</div>

													</li>
												</ul>
											</div>
										</div>
									</div>
								</div>
								</div>
								<div class="comment-main-field">
									<img *ngIf="!userPic" src="assets/img/user-profile.svg">
									<img *ngIf="userPic" src="{{userPic}}">
									<div class="comment-highlight-field">
									<form class="form-horizontal search-area-field" [formGroup]="mainMsgForm" (ngSubmit)="onSubmitCommentSection(currentIllus.id, mainMsgData.value, currentIllus.board)">
										<div class="center-header" style="position: relative;">
											<div>
												<div class="p-3 border-shadow comments-users-list" *ngIf="showUsersListDialog">
													 <ul class="list-group">
														 <li (click)="selectedTagUser(users.user_id, users.fullName)" class="" *ngFor="let users of usersList; let i=index">
															 <div class="comments-user-name">
																{{getInitial(users.fullName)}}
															</div>
															 <label class="ml-2 mb-0"  class="comment-user-list-label">{{users.fullName}}</label>
														 </li>
													 </ul>
												 </div>
												<input class="search-new-box" style="width: 145%; background-color: #f5f6f7;" id="text" class="text-field" formControlName="mainmessage" maxlength="200" type="text" placeholder="Share your views" class="form-control input-md" [(ngModel)]="textArea"  autocomplete="off" (input)="hitUsersListApi($event)" #mainMsgData>
												<input style="display: none" type="Submit" value="Search" class="button">
											</div>
											<img *ngIf="showChatLoader" class="chat-loader" src="assets/img/chat-loader.gif" alt="">
										</div>
									</form>

									<button class="emo" (click)="isEmojiPickerVisible = !isEmojiPickerVisible;">
										<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M9.12002 9.12002V8.12002C8.56774 8.12002 8.12002 8.56774 8.12002 9.12002H9.12002ZM9.21565 9.12002H10.2156C10.2156 8.56774 9.76793 8.12002 9.21565 8.12002V9.12002ZM14.88 9.12002V8.12002C14.3277 8.12002 13.88 8.56774 13.88 9.12002H14.88ZM14.965 9.12002H15.965C15.965 8.56774 15.5173 8.12002 14.965 8.12002V9.12002ZM9.21565 9.1969V10.1969C9.76793 10.1969 10.2156 9.74918 10.2156 9.1969H9.21565ZM9.12002 9.1969H8.12002C8.12002 9.74918 8.56774 10.1969 9.12002 10.1969V9.1969ZM14.965 9.1969V10.1969C15.5173 10.1969 15.965 9.74918 15.965 9.1969H14.965ZM14.88 9.1969H13.88C13.88 9.74918 14.3277 10.1969 14.88 10.1969V9.1969ZM9.52226 14.3929C9.23157 13.9233 8.61525 13.7782 8.14565 14.0689C7.67605 14.3596 7.53101 14.9759 7.82169 15.4455L9.52226 14.3929ZM16.1784 15.4455C16.469 14.9759 16.324 14.3596 15.8544 14.0689C15.3848 13.7782 14.7685 13.9233 14.4778 14.3929L16.1784 15.4455ZM20.6 12C20.6 16.7497 16.7497 20.6 12 20.6V22.6C17.8542 22.6 22.6 17.8542 22.6 12H20.6ZM12 20.6C7.25037 20.6 3.40002 16.7497 3.40002 12H1.40002C1.40002 17.8542 6.14581 22.6 12 22.6V20.6ZM3.40002 12C3.40002 7.25037 7.25037 3.40002 12 3.40002V1.40002C6.14581 1.40002 1.40002 6.14581 1.40002 12H3.40002ZM12 3.40002C16.7497 3.40002 20.6 7.25037 20.6 12H22.6C22.6 6.14581 17.8542 1.40002 12 1.40002V3.40002ZM9.12002 10.12H9.21565V8.12002H9.12002V10.12ZM14.88 10.12H14.965V8.12002H14.88V10.12ZM8.21565 9.12002V9.1969H10.2156V9.12002H8.21565ZM9.21565 8.1969H9.12002V10.1969H9.21565V8.1969ZM10.12 9.1969V9.12002H8.12002V9.1969H10.12ZM13.965 9.12002V9.1969H15.965V9.12002H13.965ZM14.965 8.1969H14.88V10.1969H14.965V8.1969ZM15.88 9.1969V9.12002H13.88V9.1969H15.88ZM12 15.8C10.9702 15.8 10.0524 15.2493 9.52226 14.3929L7.82169 15.4455C8.69145 16.8506 10.2315 17.8 12 17.8V15.8ZM14.4778 14.3929C13.9477 15.2493 13.0298 15.8 12 15.8V17.8C13.7686 17.8 15.3086 16.8506 16.1784 15.4455L14.4778 14.3929Z" fill="black"/>
										</svg>
									</button>
									<br />
									<emoji-mart [style]="{ position: 'absolute', bottom: '20px', right: '20px'}" class="emoji-mart" *ngIf="isEmojiPickerVisible"
									(emojiClick)="addEmoji($event)" title="Choose your emoji"></emoji-mart>

									<svg class="send" (click)="onSubmitCommentSection(currentIllus.id, 				mainMsgData.value, currentIllus.board)" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M21.0703 2.92961L10.4063 13.5936M3.271 8.23529L19.8769 2.47406C20.8995 2.11927 21.8807 3.1004 21.5259 4.12303L15.7646 20.7289C15.37 21.8665 13.7725 21.8977 13.3337 20.7764L10.6968 14.0377C10.5651 13.7011 10.2988 13.4348 9.96226 13.3031L3.22354 10.6662C2.10219 10.2275 2.13338 8.62997 3.271 8.23529Z" stroke="black" stroke-width="2" stroke-linecap="round"/>
									</svg>
								</div>
								</div>
							</div>
						</div>
					</div>
				</div>
					</div>
				</div>
			</div>
			</div>
		</div>
	</div>

	<div
		style="width: 100%;
		background-color: rgba(0,0,0, .9);
		padding-top: 200px;"
		class="modal"
		tabindex="-1"
		role="dialog"
		[ngStyle]="{'display':shareStyle}">
		<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
			width: 35%; margin: 0 auto; text-align: center;">
			<div class="modal-content" style="position: relative; padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
			<div class="modal-body">
			<button type="button" class="close" (click)="closePopupShare()" data-dismiss="modal" aria-label="Close">
				<img src="assets/img/cross.svg" alt="download free illustrations">
			</button>
			<div class="img-container-modal">
			   <img [src]="currentIllus.image">
			</div>
			<div class="mt-2 share-class-permit">
				<h3 class="share-a-link">Share a link</h3>
				<hr>

				<div class="main-permit-sec">
					<div class="allow-download-sec">
						<div data-toggle="dropdown">
							<h5>Allow downloads <img src="assets/img/tool-tip.svg" alt="" mat-raised-button #tooltip="matTooltip"
		        	matTooltip="Assets can be downloaded by users with whom you share it."
		        	matTooltipPosition="above"
							matTooltipClass="custom-tooltip"></h5>
							<p class="dropdown-menu allow-download-info">Assets can be downloaded by users with whom you share it.</p>
	          </div>
						<div class="allow-checkbox">
							<label *ngIf="planName != 'Free'" class="switch-share-settings" [(ngModel)]="allowDownloadSelected" (change)="allowDownload()">
								<input type="checkbox" checked>
								<span class="slider round"></span>
							</label>

							<p class="go-pro" *ngIf="planName == 'Free'" (click)="goProClick(); imgSearchModal.close()">Go pro</p>
						</div>
					</div>

					<div class="allow-download-sec">
						<h5>Expire link</h5>
						<div class="allow-checkbox">
							<select *ngIf="planName != 'Free'" (change)="selectExpireLink($event)" class=" input-md" id="expireLink">
								<option value="f">Never</option>
								<option value="d">1 day</option>
								<option value="w">1 week</option>
								<option value="m">1 month</option>
							</select>

							<p class="go-pro" *ngIf="planName == 'Free'" (click)="goProClick(); imgSearchModal.close()">Go pro</p>
						</div>
					</div>

					<!-- <div class="allow-download-sec">
						<h5>Show comments</h5>
						<div class="allow-checkbox">
							<label class="switch-share-settings" [(ngModel)]="showCommentSelected" (click)="allowShowComments()">
								<input type="checkbox" checked>
								<span class="slider round"></span>
							</label>
						</div>
					</div>

					<div class="allow-download-sec">
						<h5>Allow commenting</h5>
						<div class="allow-checkbox">
							<label class="switch-share-settings" [(ngModel)]="allowCommentingSelected" (click)="allowCommenting()">
								<input type="checkbox" checked>
								<span class="slider round"></span>
							</label>
						</div>
					</div> -->
				</div>
				<div class="d-flex email-input-share-link mt-3" *ngIf="isHideShareLinkGenerated" (click)="showGeneratedLink()">
					<div class="text-muted no-sharable">No shareable link</div>
					<button class="button create-share-link">Create Link</button>
				</div>
				<div class="d-flex email-input-share-link mt-3" *ngIf="isShowShareLinkGenerated">
					<div class="share-link-field">
						<input type="" name="" value="{{shareableLink}}" class="" placeholder="Generated Link" #copysharelink>
					</div>
					<button class="create-share-link" (click)="copyShareLink(copysharelink)">Copy</button>
				</div>
				<div class="no-account-txt">
					<p>Anyone can view. No account required.</p>
					<div class="link-copied" *ngIf="showLinkCopied">
						<p>Copied to clipboard</p>
					</div>
				</div>
			</div>
			</div>
		</div>
	</div>
</div>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
	padding-top: 200px;"
	class="modal"
	tabindex="-1"
	role="dialog"
	[ngStyle]="{'display':uploadVersionStyle}">
	<div class="modal-dialog" role="document" style="display: inline-block; height: 300px;
		width: 35%; margin: 0 auto;">
		<div class="modal-body" style="padding: 20px; background-color: rgb(255,255,255); border-radius: 10px;">
			<div class="modal-content" style="background-color: #fff">
				<div class="modal-body upload-options-section">
					<button type="button" class="close" (click)="closeUploadReplaceDialog()" data-dismiss="modal" aria-label="Close" style="margin-left: auto; cursor: pointer;">
						<img src="assets/img/cross.svg" alt="download free illustrations">
					</button>
					<h4 style="margin-top:10px; text-align:left;"><b>Upload a version?</b></h4>
					<p style="margin-top:10px; text-align:left;">You are about to upload a version to this asset.</p>
					<div class="button-wrapper upload-asset-section" style="display: flex; margin-top: 10px;
						float: right;">
						<a href="javascript:;" style="color: #333333; background-color: #FFFFFF;margin-right: 20px;" class="button upload-cancel-btn" (click)="closeUploadReplaceDialog()">Cancel</a>
						<input type="file" accept="application/* && pdf/* && image/* && video/*" multiple (change)="selectFilesVersion($event, currentSearchIllusPosition, boardHeading, currentIllus.board, currentIllus.id)" #fileInput>
						<a href="javascript:;" class="button" (click)="fileInput.click(); closeUploadReplaceDialog()">Upload</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
</ng-template>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
  padding-top:200px;"
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{'display':deleteBoardStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
			<button style="text-align: end;" type="button" class="close" (click)="closeDeleteBoardShare()" data-dismiss="modal" aria-label="Close">
				<img src="assets/img/cross.svg" alt="download free illustrations">
			</button>
			<div class="modal-body">
				<img src="assets/img/delete_img.svg" alt="delete">
				<p></p>
				<br>
				<h3 style="margin-bottom:40px;">Delete {{deleteBoardName}}?</h3>
				<!-- <p style="margin-bottom:30px; margin-top:8px;">You'll not be able to recover it.</p> -->
				<div class="button-wrapper delete-leave-workspace">
					<a href="javascript:;" class="button cancel-dialog-btn" (click)="closeDeleteBoardShare()">Cancel</a>
					<a href="javascript:;" class="button google-login-btn" *ngIf="showDeleteLeaveLoader"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></a>
					<a href="javascript:;" class="button google-login-btn" (click)="deleteBoard()"
					*ngIf="!showDeleteLeaveLoader">Delete</a>
				</div>
			</div>

		</div>
	</div>
</div>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
  padding-top:200px;"
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{'display':deleteProcessStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
			<div class="modal-body">
				<img class="main-loader-img" style="width: 140px;" src="assets/img/loader.svg" alt="">
			  <h6>Please wait</h6>
			  <p>In progress..</p>
			</div>
		</div>
	</div>
</div>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
	padding-top: 120px;"
	class="modal"
	tabindex="-1"
	role="dialog"
	[ngStyle]="{'display':shareLinkStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
		<div class="modal-body">
			<button type="button" class="close" (click)="closeShareLinkStyle()" data-dismiss="modal" aria-label="Close">
				<img src="assets/img/cross.svg" alt="download free illustrations">
			</button>
		<div class="img-container-modal">
		   <img src={{shareImageLink}}>
		</div>
		<div class="mt-2 share-class-permit">
			<h3 class="share-a-link">Share a link</h3>
			<hr>

			<div class="main-permit-sec">
				<div class="allow-download-sec">
					<div data-toggle="dropdown">
						<h5>Allow downloads <img src="assets/img/tool-tip.svg" alt="" mat-raised-button #tooltip="matTooltip"
	        	matTooltip="Assets can be downloaded by users with whom you share it."
	        	matTooltipPosition="above"
						matTooltipClass="custom-tooltip"></h5>
						<p class="dropdown-menu allow-download-info">Assets can be downloaded by users with whom you share it.</p>
          </div>
					<div class="allow-checkbox">
						<label *ngIf="planName != 'Free'" class="switch-share-settings" [(ngModel)]="allowDownloadSelected" (change)="allowDownload()">
							<input type="checkbox" checked>
							<span class="slider round"></span>
						</label>

						<p class="go-pro" *ngIf="planName == 'Free'" (click)="goProClick()">Go pro</p>
					</div>
				</div>

				<div class="allow-download-sec">
					<h5>Expire link</h5>
					<div class="allow-checkbox">
						<select *ngIf="planName != 'Free'" (change)="selectExpireLink($event)" class=" input-md" id="expireLink">
							<option value="f">Never</option>
							<option value="d">1 day</option>
							<option value="w">1 week</option>
							<option value="m">1 month</option>
						</select>

						<p class="go-pro" *ngIf="planName == 'Free'" (click)="goProClick()">Go pro</p>
					</div>
				</div>

				<!-- <div class="allow-download-sec">
					<h5>Show comments</h5>
					<div class="allow-checkbox">
						<label class="switch-share-settings" [(ngModel)]="showCommentSelected" (click)="allowShowComments()">
							<input type="checkbox" checked>
							<span class="slider round"></span>
						</label>
					</div>
				</div>

				<div class="allow-download-sec">
					<h5>Allow commenting</h5>
					<div class="allow-checkbox">
						<label class="switch-share-settings" [(ngModel)]="allowCommentingSelected" (click)="allowCommenting()">
							<input type="checkbox" checked>
							<span class="slider round"></span>
						</label>
					</div>
				</div> -->
			</div>
			<div class="d-flex email-input-share-link mt-3" *ngIf="isHideShareLinkGenerated" (click)="showGeneratedLink()">
				<div class="text-muted no-sharable">No shareable link</div>
				<button class="button create-share-link">Create Link</button>
			</div>
			<div class="d-flex email-input-share-link mt-3" *ngIf="isShowShareLinkGenerated">
				<div class="share-link-field">
					<input type="" name="" value="{{shareableLink}}" class="" placeholder="Generated Link" #copysharelink>
				</div>
				<button class="create-share-link" (click)="copyShareLink(copysharelink)">Copy</button>
			</div>
			<div class="no-account-txt">
				<p>Anyone can view. No account required.</p>
				<div class="link-copied" *ngIf="showLinkCopied">
					<p>Copied to clipboard</p>
				</div>
			</div>
		</div>
		</div>
		</div>
	</div>
</div>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
	padding-top:100px;"
	class="modal"
	tabindex="-1"
	role="dialog"
	[ngStyle]="{'display':moveImagesStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: auto;
		width: 40%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
			<button style="text-align: end;" type="button" class="close" (click)="closeMoveImagesStyleBoard()" data-dismiss="modal" aria-label="Close">
				<img src="assets/img/cross.svg" alt="download free illustrations">
			</button>
			<div class="modal-body move-top-dialog">
				<h5>Move To</h5>
				<p>The assets moved from current board will appear on a new(selected) board.</p>
				<form class="custom-form search-area-field ant-input-search-field" (ngSubmit)="onSearchBoards()" #heroForm="ngForm">
				<input placeholder="Search Boards" data-test-name="invite-email-input" class="ant-input-search-field-section" type="text" value="" name="boardSearchKeyword" [(ngModel)]="boardSearchKeyword" required>
				<!-- <i class="fa fa-plus plus-icons"></i> -->
				<input style="display: none" type="Submit" class="button">
				</form>
				<h6 *ngIf="moveBoards.length == 0" style="text-align: center;">No Boards found</h6>
				<h6 *ngIf="moveBoards.length > 0">Workspace Boards</h6>
				<div class="button-wrapper move-to-board" *ngIf="moveBoards.length > 0">
					<div class="" *ngIf="showSearchBoardOlderList">
						<ul class="list-group select-board-to-move" *ngFor="let boardlist of moveBoards  | slice:0:10">
							<li class="select-board-to-move" (click)="moveImagesToOtherBoard(boardlist.id, boardlist.title)">
							<span class="board-name-btn">{{ boardlist.title }}</span>
							<i class="fa fa-plus plus-icons"></i>
							</li>
						</ul>
					</div>

					<div class="" *ngIf="showSearchBoardList">
						<ul class="list-group" *ngFor="let boardlist of searchedBoards  | slice:0:10">
							<li class="select-board-to-move" (click)="moveImagesToOtherBoard(boardlist.id, boardlist.title)">
							<span class="board-name-btn">{{ boardlist.title }}</span>
							<i class="fa fa-plus plus-icons"></i>
							</li>
						</ul>
						<h6 *ngIf="searchedBoards.length == 0" style="margin-bottom:10px; text-align:center; font-size: 14px ;color: #000;">No Boards found</h6>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
	padding-top: 200px;"
	class="modal"
	tabindex="-1"
	role="dialog"
	[ngStyle]="{'display':assetRenameStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="position: relative; padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
		<div class="modal-body">
		<button type="button" class="close" (click)="closeAssetRenameDialog()" data-dismiss="modal" aria-label="Close">
			<img src="assets/img/cross.svg">
		</button>
		<div class="img-container-modal">
		   <img src={{renameImageLink}}>
		</div>
		<div class="mt-2 share-class-permit">
			<h3 class="share-a-link">Rename asset</h3>
			<div class="d-flex email-input-share-link mt-3" *ngIf="isShowShareLinkGenerated">
				<div class="rename-link-field">
					<input type="" name="" value="{{assetCurrentName}}" class="" placeholder="Generated Link" [(ngModel)]="assetNewName">
				</div>
			</div>
			<p>{{renameErrorMsg}}</p>
			<div class="rename-save-btn">
				<button class="button cancel-button" (click)="closeAssetRenameDialog()">Cancel</button>
				<button *ngIf="!showRenameLoader" class="button create-rename-link" (click)="assetRename()">Save</button>
				<button *ngIf="showRenameLoader" class="button create-rename-link"><img style="height: 18px;" src="assets/img/img-up-white.svg"></button>
			</div>
		</div>
		</div>
	</div>
</div>
</div>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
	padding-top: 200px;"
	class="modal"
	tabindex="-1"
	role="dialog"
	[ngStyle]="{'display':assetEditTagsStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="position: relative; padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
		<div class="modal-body">
		<button type="button" class="close" (click)="closeEditTagsDialog()" data-dismiss="modal" aria-label="Close">
			<img src="assets/img/cross.svg">
		</button>
		<div class="img-container-modal">
			<img *ngIf="editTagsImageFormats == 'PNG' || editTagsImageFormats == 'JPG'  || editTagsImageFormats == 'SVG' || editTagsImageFormats == 'JPEG' || editTagsImageFormats == 'GIF' || editTagsImageFormats == 'BMP' || editTagsImageFormats == 'ICO' || editTagsImageFormats == 'TIFF' || editTagsImageFormats == 'WEBP'" src={{editTagsImageLink}}>
			<img *ngIf="editTagsImageFormats == 'AI'" src="assets/img/ai-icon.svg">
			<img *ngIf="editTagsImageFormats == 'EPS'" src="assets/img/eps-icon.svg">
			<img *ngIf="editTagsImageFormats == 'ZIP'" src="assets/img/zip-icon.svg">
			<img *ngIf="editTagsImageFormats == 'PAGES' || editTagsImageFormats == 'NUMBERS'" src="assets/img/pages.svg">
			<video src={{editTagsImageLink}} *ngIf="editTagsImageFormats == 'MP4' || editTagsImageFormats == 'WEBM' || editTagsImageFormats == 'FLV' || editTagsImageFormats == 'WMV' || editTagsImageFormats == 'MOV'" style="height: 154px;" controls></video>
			<img src="assets/img/psd.svg" alt="" *ngIf="editTagsImageFormats == 'PSD'">
		</div>
		<div class="mt-2 share-class-permit">
			<h3 class="share-a-link">Edit tags</h3>
			<div class="d-flex email-input-share-link mt-3" *ngIf="isShowShareLinkGenerated">
				<form [formGroup]="tagsForm" class="custom-form search-area-field" (ngSubmit)="onSubmitMultipleTags()" #heroForm="ngForm">
					<div class="edit-tag-field">
						<div class="mat-chip-main" *ngIf="editTagsList.length > 0">
							<ul class="mat-chip-list-main">
								<li class="mat-chip-list" *ngFor="let addedTags of editTagsList; let i = index">
									<span class="chip-txt"><a>{{ addedTags }}</a>
										<span (click)="removeAddedTags(i)" role="img" aria-label="close" tabindex="-1" class="anticon anticon-close ant-tag-close-icon">
											<svg viewBox="64 64 896 896" focusable="false" data-icon="close" width="1em" height="1em" fill="#a9a9a9" aria-hidden="true">
												<path d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z">
												</path>
											</svg>
										</span>
									</span>
								</li>
							</ul>
						</div>
						<input formControlName="edittags" type="text" class="" placeholder="Add tags">
					</div>
				</form>
			</div>
			<p>{{editTagsError}}</p>
			<div class="rename-save-btn">
				<button class="button cancel-button" (click)="closeEditTagsDialog()">Cancel</button>
				<button *ngIf="!showEditTagsLoader" class="button create-rename-link" (click)="editMultipleTags()">Add</button>
				<button *ngIf="showEditTagsLoader" class="button create-rename-link"><img style="height: 18px;" src="assets/img/img-up-white.svg"></button>
			</div>
		</div>
		</div>
	</div>
</div>
</div>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
	padding-top: 200px;"
	class="modal"
	tabindex="-1"
	role="dialog"
	[ngStyle]="{'display':boardRenameStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="position: relative; padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
		<div class="modal-body">
		<button type="button" class="close" (click)="closeEditBoardNames()" data-dismiss="modal" aria-label="Close">
			<img src="assets/img/cross.svg">
		</button>
		<div class="img-container-modal">
		   <img src={{renameImageLink}}>
		</div>
		<div class="mt-2 share-class-permit">
			<h3 class="share-a-link">Rename board</h3>
			<div class="d-flex email-input-share-link mt-3">
				<div class="rename-link-field">
					<input type="" name="" value="{{boardCurrentName}}" class="" placeholder="Board name" [(ngModel)]="boardNewName">
				</div>
			</div>
			<p>{{renameErrorMsg}}</p>
			<div class="rename-save-btn">
				<button class="button cancel-button" (click)="closeEditBoardNames()">Cancel</button>
				<button *ngIf="!showRenameLoader" class="button create-rename-link" (click)="editBoardNamesApi()">Save</button>
				<button *ngIf="showRenameLoader" class="button create-rename-link"><img style="height: 18px;" src="assets/img/img-up-white.svg"></button>
			</div>
		</div>
		</div>
	</div>
</div>
</div>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
	padding-top: 150px;"
	class="modal"
	tabindex="-1"
	role="dialog"
	[ngStyle]="{'display':createWorkspaceStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="position: relative; padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
			<div class="modal-body new-create-workspace-dialog">
				<button style="margin: -10px;" type="button" class="close" (click)="closeNewWorkspaceDialog()" data-dismiss="modal" aria-label="Close">
					<img src="assets/img/cross.svg">
				</button>
				<div class="mt-2 share-class-permit">
					<div class="inner-content welcome-txt" style="background-color: #fff">
						<h6>Create Workspace</h6>
						<p class="create-space-p">Create and customise a workspace as per your requirements.</p>
						<div class="create-workspace-txt">
							<p>Name Workspace</p>
						</div>
						<div class="btn-wrapper">
							<form style="width: 100%" class="form-horizontal" [formGroup]="creatwWorkspace" (ngSubmit)="createWorkspace(workspaceNames.value)">
								<input maxlength="50" formControlName="message" placeholder="Your workspace name" data-test-name="invite-email-input" class="workspace-ant-input-invite-field" type="text" value="" #workspaceNames>
							</form>
						</div>
						<span class="text-danger error-text board-error-text" *ngIf="isShowCreateWorkspaceError">{{createWorkspaceErrorMessage}}</span>
						<span class="text-danger error-text board-error-text" *ngIf="isShowCreateLoginWorkspaceError" style="cursor: pointer;"><b>{{createWorkspaceLoginErrorMessage}}</b></span>
						<button *ngIf="!showLeaveLoader" style="width: 100%" [disabled]="workspaceNames.value === ''" data-test-name="send-invite-button" type="button" class="ant-btn-create-org ant-btn-default ant-input-search-button" (click)="createWorkspace(workspaceNames.value)"><span role="img" aria-label="plus" class="create-workspace-span">Create Workspace</span></button>

						<button *ngIf="showLeaveLoader" style="width: 100%" data-test-name="send-invite-button" type="button" class="ant-btn-create-org ant-btn-default ant-input-search-button">
							<img class="img-up-loader" style=height: 18px;" src="assets/img/img-up-white.svg" alt="">
						</button>

						<button type="button" name="button" class="new-workspace-cancel" (click)="closeNewWorkspaceDialog()">Cancel</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
